( function( ) {
	// Javascript functions necesarias para el funcionamiento
	var tareaslistas = 0;
	function revisarprogreso() {
		tareaslistas++;
		if(tareaslistas >= 5) {
			$('.preloadoverlay').fadeOut(300);
		};
	};

	function escapeRegExp(str) {
	    return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
	};

	function replaceAll(str, find, replace) {
		return str.replace(new RegExp(escapeRegExp(find), 'g'), replace);
	};

	Vue.component('pacientes', {
		template: '#pacientes-template',

		props: ['idmedico'],

		data: function() {
			return {
				list: [],
				contar: 0,
				loading: true,
				errores: false,
			};
		},

		created: function() {
			this.fetchListaPacientes();
		},

		methods: {
			fetchListaPacientes: function(){
				this.$http.get('/api/mis-pacientes/'+ this.idmedico , function (pacientes){
					this.list = pacientes.listado;
					this.contar = pacientes.count;
					this.errores = false;
				})
				.then(function (){ },
					function (){ this.errores = true; }
				);
				this.loading = false;
			},
		}
	});

	Vue.component('citas', {
		template: '#citas-template',

		props: ['idmedico'],

		data: function() {
			return {
				list: [],
				contar: 0,
				loading: true,
				errores: false,
				citaTime: 0,
			};
		},

		created: function() {
			this.fetchListCitas();
		},

		methods: {
			fetchListCitas: function(){
				this.$http.get('/api/mis-citas/'+ this.idmedico, function (citasd){
					this.list = citasd[0];
					this.contar = citasd.citastotal;
				})
				.then(function (){
					this.errores = false;
				}, function() {
					this.errores = true;
				});
				this.loading = false;
			},
			deleteCitas: function(id) {
				respuesta = confirm('Favor de confirmar que desea eliminar el registro.');
				var valuetoken = document.querySelector('#_token').getAttribute('value');
				if(respuesta) {

					this.$http.post('/api/delete/citas', {
						id: id,
						_token: valuetoken,
					})
					.then(function (){
						alert('Se ha eliminado la cita');
						this.fetchListCitas();
					}, function() {
						alert('No se pudo eliminar la cita');
					});

				}
			}
		},
	});

	Vue.component('consultas', {
		template: '#consultas-hoy',

		props: ['idmedico'],

		data: function() {
			return {
				list: [],
				contar: 0,
				loading: true,
				errores: false,
			};
		},

		created: function() {
			this.fetchListConsultas();
		},

		methods: {
			fetchListConsultas: function(){
				this.$http.get('/api/mis-consultas/'+ this.idmedico, function (consulta){
					this.list = consulta;
					this.contar = consulta.length;
				})
				.then(function (){
					this.errores = false;
				}, function(){
					this.errores = true;
				});
				this.loading = false;
			},
			deleteConsulta: function(id) {
				respuesta = confirm('Favor de confirmar que desea eliminar el registro.');
				if(respuesta) {
					this.$http.get('/api/citas/eliminacita/' + id, function(){
						alert('Se ha eliminado la cita');
						this.fetchListConsultas();
					});
				}
			}
		}
	});

	Vue.component('buscapaciente', {
		template: '#buscarPaciente',

		props: ['idmedico', 'nombremedico'],

		data: function(){
			return {
				listadopacientes: [],
				search: '',
				mostrar: false,
				idPaciente: '',
				fecha: '',
				search: '',
				Nombre: '',
				ApellidoPaterno: '',
				ApellidoMaterno: '',
				anio: '',
				mes: '',
				dia: '',
				Sexo: '',
				Telefono1: '',
				Telefono2: '',
				Telefono3: '',
				CorreoElectronico: '',
				_token: '',
				aviso: true,
				errorcarga: false,
				errores: false,
				Loaderinicio: true,
				errorcarga: false,
				Loader: false,
				mostrar: false,
				mostrarmedico: false,
				modal: false,
				nuevopaciente: false,
				agregar: true,
				mostrarinputpacientes: false,
			}
		},

		created: function() {
			this.getListaPacientes();
		},

		methods: {
			getListaPacientes: function() {
				this.$http.get('/api/mi-lista-pacientes/' + this.idmedico, function (mispacientes){
					this.listadopacientes = mispacientes;
				})
				.then(function (){
					this.Loaderinicio = false;
					this.aviso = true;
					this.mostrarinputpacientes = true;
				}, function() {
					this.Loaderinicio = false;
					this.errores = true;
					this.errorcarga = true;
				});
			},
			selectPaciente: function(paciente) {
				this.search = paciente.Nombre + ' ' + paciente.ApellidoPaterno + ' ' + paciente.ApellidoMaterno;
				this.mostrar = false;
				this.idPaciente = paciente.idPaciente;
			},
			mostrarpacientes: function(nombre) {
				this.mostrar = true;
			},
			openModal: function() {
				this.modal = true;
				this.nuevopaciente = true;
				this.agregar = true;
			},
			closeModal: function() {
				this.modal = false;
				this.nuevopaciente = false;
			},
			agregarPaciente: function() {
				this.Loader = true;
				this.agregar = false;
				this.errores = false;
				this.fecha = this.anio + '-' + this.mes + '-' + this.dia;
				this.$http.post('/api/nuevo-paciente', {
					_token: this.token,
					IdMedico: this.idmedico,
					idPaciente: this.idPaciente,
					Nombre: this.Nombre,
					ApellidoPaterno: this.ApellidoPaterno,
					ApellidoMaterno: this.ApellidoMaterno,
					FechaNacimiento: this.fecha,
					Sexo: this.Sexo,
					Telefono1: this.Telefono1,
					Telefono2: this.Telefono2,
					Telefono3: this.Telefono3,
					CorreoElectronico: this.CorreoElectronico,
				})
				.then(function(paciente) {
					this.exito = true;
					this.selectPaciente(paciente.data);
					this.Loader = false;
					this.closeModal();
					this.getListaPacientes();
				}, function() {
					this.agregar = true;
					this.Loader = false;
					this.errores = true;
				});
			},
			volveracargarpaciente: function() {
				this.Loaderinicio = true;
				this.errorcarga = false;
				this.getListaPacientes();
			},
		}
	});

	Vue.component('pacientes-sociedad', {
		template: '#pacientes-sociedad',

		props: ['idsociedad'],

		data: function(){
			return {
				listadopacientessociedad: [],
				listamedicossociedad: [],
				elmedico: '',
				elnombredelmedico: '',
				idmedico: '',
				idpaciente: '',
				nombremedico: '',
				fecha: '',
				search: '',
				Nombre: '',
				ApellidoPaterno: '',
				ApellidoMaterno: '',
				anio: '',
				mes: '',
				dia: '',
				Sexo: '',
				Telefono1: '',
				Telefono2: '',
				Telefono3: '',
				CorreoElectronico: '',
				aviso: false,
				errorcarga: false,
				errores: false,
				Loaderinicio: true,
				Loader: false,
				mostrar: false,
				mostrarmedico: false,
				modal: false,
				nuevopaciente: false,
				agregar: true,
			}
		},

		created: function() {
			this.getMedicos();
			this.getListaPacientes();
		},

		methods: {
			getMedicos: function () {
				this.errorcarga = false;
				this.mostrarmedico = false;
				this.$http.get('/api/lista-medicos-sociedad/' + this.idsociedad, function(medicos) {
					this.listamedicossociedad = medicos;
				})
				.then(function() {
					this.Loaderinicio = false;
					this.aviso = true;
					this.mostrarmedico = true;
				}, function() {
					this.aviso = false;
					this.Loaderinicio = false;
					this.errorcarga = true;
				});
			},
			getListaPacientes: function() {
				this.errores = false;
				this.$http.get('/api/pacientes-sociedad/' + this.idsociedad, function (pacientes){
					this.listadopacientessociedad = pacientes;
				})
				.then(function (){
					this.loading = false;
				}, function() {
					this.aviso = false;
					this.errorcarga = true;
					this.loading = false;
					this.errores = true;
				});
			},
			selectPaciente: function(paciente) {
				this.search = paciente.Nombre + ' ' + paciente.ApellidoPaterno + ' ' + paciente.ApellidoMaterno;
				this.mostrar = false;
				this.idpaciente = paciente.idPaciente;
			},
			mostrarpacientes: function(nombre) {
				this.mostrar = true;
			},
			actualizarConsulta: function() {
				this.getMedicos();
			},
			cambiarmedico: function() {
				this.listamedicossociedad.forEach(function(entry) {
					if(entry.IdMedico == this.elmedico) {
						this.elnombredelmedico = entry.Nombre + ' ' + entry.ApellidoPaterno + ' ' + entry.ApellidoMaterno;
						this.idmedico = entry.IdMedico;
					}
				}.bind(this));
			},
			openModal: function() {
				this.modal = true;
				this.nuevopaciente = true;
				this.agregar = true;
			},
			closeModal: function() {
				this.modal = false;
				this.nuevopaciente = false;
			},
			agregarPaciente: function() {
				this.Loader = true;
				this.agregar = false;
				this.errores = false;
				this.fecha = this.anio + '-' + this.mes + '-' + this.dia;
				this.$http.post('/api/nuevo-paciente', {
					IdMedico: this.idmedico,
					Nombre: this.Nombre,
					ApellidoPaterno: this.ApellidoPaterno,
					ApellidoMaterno: this.ApellidoMaterno,
					FechaNacimiento: this.fecha,
					Sexo: this.Sexo,
					Telefono1: this.Telefono1,
					Telefono2: this.Telefono2,
					Telefono3: this.Telefono3,
					CorreoElectronico: this.CorreoElectronico,
				})
				.then(function(paciente) {
					this.exito = true;
					this.selectPaciente(paciente.data);
					this.Loader = false;
					this.closeModal();
				}, function() {
					this.agregar = true;
					this.Loader = false;
					this.errores = true;
				});
			}
		},
	});

	Vue.component('especialidad', {

		template: '#directorio-especialidades',

		props: ['idespecialidad'],

		data: function(){
			return {
				listadoespecialidades: [],
				mostrar: false,
				firstLoader: false,
				errorencarga: true,
			}
		},

		created: function() {
			this.fetchListEspecialidades();
		},

		methods: {
			fetchListEspecialidades: function(nombre) {
				this.firstLoader = true;
				this.errorencarga = false;
				this.$http.get('/api/lista-especialidades/', function (especialidades){
					this.listadoespecialidades = especialidades;
				})
				.then(function (){
					this.firstLoader = false;
					this.mostrar = true;
				}, function() {
					this.firstLoader = false;
					this.errorencarga = true;
				});
			},
			volveracargar: function() {
				this.fetchListEspecialidades();
			}
		}
	});

	Vue.component('mispacientes', {
		template: '#misPacientes',

		props: ['idmedico'],

		data: function(){
			return {
				listadopacientes: [],
				search: '',
				mostrar: false,
			}
		},

		created: function() {
			this.fetchListaPacientes();
		},

		methods: {
			startOver: function(paciente) {
				this.search = '';
				this.mostrar = false;
			},
			fetchListaPacientes: function(nombre) {
				this.$http.get('/api/mi-lista-pacientes-hashed/' + this.idmedico, function (pacientes){
					this.listadopacientes = pacientes;
				})
				.then(function (){
					this.loading = false; this.errores = false;
				}, function(){
					this.loading = false;
					this.errores = true;
				});
			},
			mostrarlalista: function() {
				this.mostrar = true;
			},
			encriptar: function(id) {
				var elvalor;
				this.$http.get('/api/encrypt/' + id, function(data) {
					elvalor = data;
				});
				return elvalor;
			},
		},
	});

	Vue.component('mismedicos', {
		template: '#misMedicos',

		props: ['idMedico'],

		data: function(){
			return {
				listadomedicos: [],
				search: '',
				mostrarlista: false
			}
		},

		created: function() {
			this.fetchListaMedicos();
		},

		methods: {
			startOver: function(paciente) {
				this.search = '';
				this.mostrarlista = false;
			},
			fetchListaMedicos: function(nombre) {
				this.$http.get('/api/mis-medicos/' + this.idMedico, function (medicos){
					this.listadomedicos = medicos;
				})
				.then(function (){
					this.loading = false;
				}, function(){
					this.loading = false;
					this.errores = true;
				});
			},
			mostrarlalista: function() {
				this.mostrarlista = true;
			}
		}
	});

	Vue.component('medicostodos', {
		template: '#Medicos',

		data: function(){
			return {
				listadomedicos: [],
				search: '',
				mostrar: false
			}
		},

		created: function() {
			this.fetchListaMedicos();
		},

		methods: {
			startOver: function(paciente) {
				this.search = '';
				this.mostrar = false;
			},
			fetchListaMedicos: function(nombre) {
				this.$http.get('/api/lista-medicos/', function (medicos){
					this.listadomedicos = medicos;
				})
				.then(function (){
					this.loading = false;
				}, function(){
					this.loading = false;
					this.errores = true;
				});
			},
			mostrarlalista: function() {
				this.mostrar = true;
			}
		}
	});

	Vue.component('paciente', {
		template: '#buscarPaciente',

		props: ['idsociedad'],

		data: function(){
			return {
				listadopacientes: [],
				listadomedicos: [],
				search: '',
				mostrar: false,
				idPaciente: '',
				IdMedico: '0'
			}
		},

		created: function() {
			this.fetchListaPacientes();
			this.fetchListaMedicos();
		},

		methods: {
			startOver: function(paciente) {
				this.search = '';
				this.mostrar = false;
			},
			fetchListaPacientes: function(nombre) {
				this.$http.get('/api/asistente-pacientes/' + this.idsociedad, function (pacientes){
					this.listadopacientes = pacientes;
				})
				.then(function (){
					this.loading = false;
				}, function(){
					this.loading = false;
					this.errores = true;
				});
			},
			fetchListaMedicos: function(nombre) {
				this.$http.get('/api/asistente-medicos/' + this.idsociedad, function (medicos){
					this.listadomedicos = medicos;
				})
				.then(function (){
					this.loading = false;
				}, function(){
					this.loading = false;
					this.errores = true;
				});
			},
			mostrarpacientes: function() {
				this.mostrar = true;
				this.idPaciente = '';
				this.IdMedico = '';
			},
			selectPaciente: function(paciente) {
				this.search = paciente.Nombre + ' ' + paciente.ApellidoPaterno + ' ' + paciente.ApellidoMaterno;
				this.mostrar = false;
				this.idPaciente = paciente.idPaciente;
				this.IdMedico = paciente.IdMedico;
			},
		}
	});

	Vue.component('sociedades', {
		template: '#buscarSociedades',

		data: function(){
			return {
				listadosociedades: [],
				search: '',
				mostrar: false
			}
		},

		created: function() {
			this.getListaSociedades();
		},

		methods: {
			selectSociedad: function(sociedad) {
				this.search = sociedad.Nombre + ' ' + sociedad.ApellidoPaterno + ' ' + sociedad.ApellidoMaterno;
				this.mostrar = false;
			},
			getListaSociedades: function() {
				this.$http.get('/api/lista-sociedades/', function (lassociedades){
					this.listadosociedades = lassociedades;
				})
				.then(function (){
					this.loading = false;
				}, function(){
					this.loading = false;
					this.errores = true;
				});
			},
			mostrarsociedades: function(nombre) {
				this.mostrar = true;
			}
		}
	});

	Vue.component('contarconsulta-previa', {

		template: '#consulta-previa',

		props: ['idpaciente'],

		data: function() {
			return {
				contarprevias: '',
				errores: false,
			}
		},

		created: function() {
			this.fetchCuentaConsultasPrevias();
		},

		methods: {
			fetchCuentaConsultasPrevias: function() {
				this.$http.get('/api/consulta/cuenta/previas/paciente/' + this.idpaciente , function (consultas){
					if(consultas > 0) { this.contarprevias = consultas; }
				})
				.then(function (consultas){
					this.errores = false;
				}, function(){
					this.errores = true;
				});
			}
		},
	});

	Vue.component('estudio-gabinete',{
		template: '#estudio-gabinete',

		props: ['url', 'tipo'],

		data: function() {
			return {
				estudios: false,
				listadoEstudios: [],
				finalEstudios: [],
				errores: false,
				search: '',
				mostrar: false,
				inputEstudios: [],
				inputName: '',
			}
		},

		created: function() {
			this.inputName = this.tipo;
			this.fetchEstudios();
		},

		methods: {
			fetchEstudios: function() {
				this.$http.get(this.url, function(gabinete){
					this.listadoEstudios = gabinete;
					this.estudios = gabinete.length;
				})
				.then(function (){
					this.errores = false;
				}, function(){
					this.errores = true;
				});
			},
			mostrarlalista: function() {
				this.mostrar = true;
			},
			putItem: function(estudio) {
				this.clearItems();
				this.search = estudio.Estudio;
			},
			startOver: function() {
				this.clearItems();
			},
			clearItems: function() {
				this.search = '';
				this.mostrar = false;
			},
			agregarEstudio: function() {
				this.finalEstudios.push(this.search);
				this.inputEstudios = this.finalEstudios;
				this.clearItems();
			},
			deleteEstudio: function(index) {
				this.finalEstudios.splice(index, 1);
				this.inputEstudios = this.finalEstudios;
			}
		},
	}),

	Vue.component('estudio-gabinete-editar',{
		template: '#estudio-gabinete-editar',

		props: ['url', 'tipo', 'estudio'],

		data: function() {
			return {
				estudios: false,
				listadoEstudios: [],
				finalEstudios: [],
				errores: false,
				search: '',
				mostrar: false,
				inputName: '',
				EstudiosLista: [],
			}
		},

		created: function() {
			this.inputName = this.tipo;
			this.fetchEstudios();
			if(this.estudio) {
				this.EstudiosLista.push(this.estudio);
			}
			this.inputName = this.tipo;
		},

		methods: {
			fetchEstudios: function() {
				this.$http.get(this.url, function(gabinete){
					this.listadoEstudios = gabinete;
					this.estudios = gabinete.length;
				})
				.then(function (){
					this.errores = false;
				}, function(){
					this.errores = true;
				});
			},
			mostrarlalista: function() {
				this.mostrar = true;
			},
			putItem: function(estudio) {
				this.clearItems();
				this.search = estudio.Estudio;
			},
			startOver: function() {
				this.clearItems();
			},
			clearItems: function() {
				this.search = '';
				this.mostrar = false;
			},
			agregarEstudio: function() {
				if(this.EstudiosLista.length > 0) {
					this.EstudiosLista.push('\r\n' + this.search);
				} else  {
					this.EstudiosLista.push(this.search);
				}
				this.clearItems();
			},
			deleteEstudio: function(index) {
				this.finalEstudios.splice(index, 1);
				this.inputEstudios = this.finalEstudios;
			},
			CargarOtra: function() {
				this.fetchEstudios();
				this.errores = false;
			},
		},
	}),

	Vue.component('estudios-hc', {

		template: '#estudios-hc',

		props: ['idpaciente', 'idconsulta', 'idmedico', 'urlgabinete', 'urllaboratorio'],

		data: function() {
			return {
				actualizarEstudio: false,
				capturar: false,
				errorencarga: false,
				errores: false,
				errorgabinete: false,
				errorlaboratorio: false,
				idExpFis: '',
				exito: false,
				laforma: false,
				Loader: false,
				LoaderInicio: true,
				mostrargabinete: false,
				mostrarlaboratorio: false,
				registrarEstudio: false,
				resultado: false,
				finalEstudiosGabinete: [],
				finalEstudiosLaboratorio: [],
				inputEstudiosGabinete: [],
				inputEstudiosLaboratorio: [],
				listadoGabinete: [],
				listadoLaboratorio: [],
				misestudios: [],
				EstudiosGabinete: '',
				estudiosgabinete: '',
				EstudiosLaboratorio: '',
				estudioslaboratorio: '',
				PlanAnalisis: '',
				searchgabinete: '',
				searchlaboratorio: '',
				searchlaboratorio: '',
			}
		},

		created: function() {
			this.fetchMisEstudios(this.idconsulta);
		},

		methods: {
			fetchMisEstudios: function(idconsulta) {
				this.$http.get('/api/paciente/estudios-hc/', {
					IdPaciente: this.idpaciente,
					IdConsulta: this.idconsulta,
				})
				.then(function(datos) {
					this.misestudios = datos.data;
					this.LoaderInicio = false;
					this.errorencarga = false;
					if(datos.data == 0) {
						this.capturar = true;
						this.resultado = false;
					} else {
						this.capturar = false;
						this.resultado = true;
					}
				}, function() {
					this.LoaderInicio = false;
					this.errorencarga = true;
				});
			},
			fetchEstudiosGabinete: function() {
				this.$http.get(this.urlgabinete, function(gabinete){
					this.listadoGabinete = gabinete;
					this.estudiosgabinete = gabinete.length;
				})
				.then(function (){
					this.errorgabinete = false;
				}, function(){
					this.errorgabinete = true;
				});
			},
			fetchEstudiosLaboratorio: function() {
				this.$http.get(this.urllaboratorio, function(laboratorio){
					this.listadoLaboratorio = laboratorio;
					this.estudioslaboratorio = laboratorio.length;
				})
				.then(function (){
					this.errorlaboratorio = false;
				}, function(){
					this.errorlaboratorio = true;
				});
			},
			iniciarCaptura: function() {
				this.capturar = false;
				this.laforma = true;
				this.registrarEstudio = true;
				this.fetchEstudiosGabinete();
				this.fetchEstudiosLaboratorio();
			},
			startOver: function() {
				this.clearItems();
			},
			startOverLaboratorio: function() {
				this.clearItemsLaboratorio();
			},
			mostrarlalista: function() {
				this.mostrargabinete = true;
			},
			mostrarlalistalaboratorio: function() {
				this.mostrarlaboratorio = true;
			},
			clearItems: function() {
				this.searchgabinete = '';
				this.mostrargabinete = false;
			},
			clearItemsLaboratorio: function() {
				this.searchlaboratorio = '';
				this.mostrarlaboratorio = false;
			},
			putItem: function(estudio) {
				this.clearItems();
				this.searchgabinete = estudio.Estudio;
			},
			putItemLab: function(estudio) {
				this.clearItemsLaboratorio();
				this.searchlaboratorio = estudio.Estudio;
			},
			agregarEstudio: function() {
				this.finalEstudiosGabinete.push(this.searchgabinete);
				this.inputEstudiosGabinete = this.finalEstudiosGabinete;
				this.clearItems();
				$('#estudiosHc').garlic(); // Local Storage
			},
			agregarEstudioLaboratorio: function() {
				this.finalEstudiosLaboratorio.push(this.searchlaboratorio);
				this.inputEstudiosLaboratorio = this.finalEstudiosLaboratorio;
				this.clearItemsLaboratorio();
			},
			deleteEstudio: function(index) {
				this.finalEstudiosGabinete.splice(index, 1);
				this.inputEstudiosGabinete = this.finalEstudiosGabinete;
			},
			deleteEstudioLaboratorio: function(index) {
				this.finalEstudiosLaboratorio.splice(index, 1);
				this.inputEstudiosLaboratorio = this.finalEstudiosLaboratorio;
			},
			volveracargar: function() {
				this.LoaderInicio = true;
				this.fetchMisEstudios(this.idconsulta);
			},
			cerrarEdicion: function() {
				this.laforma = false;
				this.errores = false;
				if(this.misestudios == '' || this.misestudios.length == 0) {
					this.resultado = false;
					this.capturar = true;
				} else {
					this.resultado = true;
					this.capturar = false;
				}
			},
			cargarGabinete: function() {
				this.errorgabinete = false;
				this.fetchEstudiosGabinete();
			},
			cargarLaboratorio: function() {
				this.errorgabinete = false;
				this.fetchEstudiosLaboratorio();
			},
			guardarEstudio: function() {
				this.errores = false;
				this.registrarEstudio = false;
				this.Loader = true;
				this.$http.post('/api/registrar/hc-plan-analisis', {
					IdMedico: this.idmedico,
					IdPaciente: this.idpaciente,
					IdConsulta: this.idconsulta,
					PlanAnalisis: this.PlanAnalisis,
					EstudiosGabinete: this.inputEstudiosGabinete,
					EstudiosLaboratorio: this.inputEstudiosLaboratorio,
				})
				.then(function() {
					this.Loader = false;
					this.laforma = false;
					this.resultado = true;
					this.fetchMisEstudios(this.idconsulta);
				}, function() {
					this.errores = true;
					this.Loader = false;
				});
			},
			editarEstudios: function(estudios) {
				this.idExpFis = estudios.idExpFis;
				this.IdPaciente = estudios.IdPaciente;
				this.IdMedico = estudios.IdMedico;
				this.IdConsulta = estudios.IdConsulta;
				this.PlanAnalisis = estudios.PlanAnalisis;
				if(estudios.EstudiosGabinete != null) {
					this.finalEstudiosGabinete = estudios.EstudiosGabinete.split(' |');
				} else {
					this.finalEstudiosGabinete = [];
				}
				if(estudios.EstudiosLaboratorio != null) {
					this.finalEstudiosLaboratorio = estudios.EstudiosLaboratorio.split(' |');
				} else {
					this.finalEstudiosLaboratorio = [];
				}
				this.inputEstudiosGabinete = this.finalEstudiosGabinete;
				this.inputEstudiosLaboratorio = this.finalEstudiosLaboratorio;
				this.resultado = false;
				this.laforma = true;
				this.Loader = false;
				this.actualizarEstudio = true;
				this.fetchEstudiosGabinete();
				this.fetchEstudiosLaboratorio();
			},
			actualizaElEstudio: function() {
				this.errores = false;
				this.registrarEstudio = false;
				this.actualizarEstudio = false;
				this.Loader = true;
				this.$http.post('/api/actualizar/hc-plan-analisis', {
					idExpFis: this.idExpFis,
					IdMedico: this.idmedico,
					IdPaciente: this.idpaciente,
					IdConsulta: this.idconsulta,
					PlanAnalisis: this.PlanAnalisis,
					EstudiosGabinete: this.inputEstudiosGabinete,
					EstudiosLaboratorio: this.inputEstudiosLaboratorio,
				})
				.then(function() {
					this.Loader = false;
					this.laforma = false;
					this.resultado = true;
					this.fetchMisEstudios(this.idconsulta);
				}, function() {
					this.errores = true;
					this.Loader = false;
				});
			},
			closeErroresCaptura: function() {
				this.errores = false;
				this.registrarEstudio = true;
			},
		},
	}),

	Vue.component('diagnostico-cie10', {
		template: '#diagnostico-cie10',

		props: ['idpaciente', 'idconsulta', 'idmedico', 'status'],

		data: function() {
			return {
				evolucion: '',
				id10: '',
				idPadActual: '',
				Padecimiento: '',
				search: '',
				listacie: [],
				listadepadecimientos: [],
				listamedicamentos: [],
				agregar: false,
				agregarpadecimiento: false,
				errorconsulta: false,
				errores: false,
				exito: false,
				firstLoader: true,
				Loader: false,
				LoaderActualiza: false,
				modal: false,
				modificar: false,
				mostrarlista: false,
				nuevodiagnostico: false,
				resultados: false,
			}
		},

		created: function() {
			this.fetchPadecimientos();
		},

		methods: {
			fetchPadecimientos: function() {
				this.$http.get('/api/consulta/padecimientos/' + this.idconsulta, function(lista) {
					this.listadepadecimientos = lista;
					if(lista.length > 0) this.resultados = true;
				})
				.then(function (){
					this.firstLoader = false;
					this.errorconsulta = false;
				}, function(){
					this.firstLoader = false;
					this.errorconsulta = true;
				});
			},
			fetchmedicamentos: function() {
				this.$http.get('/api/consulta/medicamentos/' + this.idconsulta, function(lista) {
					this.listamedicamentos = lista;
				})
				.then(function (){
					this.errores = false;
				}, function(){
					this.errores = true;
				});
			},
			fetchCie: function(datos) {
				this.Loader = true;
				this.agregar = false;
				this.agregarpadecimiento = false;
				this.$http.get('/api/consulta/cie', function(cie) {
					this.listacie = cie;
				})
				.then(function (){
					if(datos == 1) {
						this.modificar = true;
						this.agregar = false;
					} else {
						this.modificar = false;
						this.agregar = true;
					}
					this.agregarpadecimiento = true;
					this.Loader = false;
				}, function(){
					this.modificar = false;
					this.Loader = false;
					this.errores = true;
				});
			},
			openModal: function() {
				this.fetchCie();
				this.modal = true;
				this.nuevodiagnostico = true;
				this.id10 = '';
				this.evolucion = '';
				this.search = '';
			},
			closemodal: function() {
				this.modal = false;
				this.nuevodiagnostico = false;
				this.agregar = false;
				this.modificar = false;
			},
			escribeCie: function(cie) {
				this.search = cie.dec10;
				this.id10 = cie.id10;
				this.mostrarlista = false;
			},
			agregarDiagnostico: function(enviar) {
				if(this.Padecimiento == '') {
					this.errores = true;
					return false;
				}
				this.agregar = false;
				this.LoaderActualiza = true;
				this.errores = false;
				this.$http.post('/api/consulta/agregar/diagnostico', {
					IdConsulta: this.idconsulta,
					IdMedico: this.idmedico,
					IdPaciente: this.idpaciente,
					id10: this.id10,
					Padecimiento: this.Padecimiento,
					Evolucion: this.evolucion,
				})
				.then(function(response) {
					this.exito = true;
					this.search = '';
					this.LoaderActualiza = false;
					this.fetchPadecimientos();
				}, function(){
					this.error = true;
					this.LoaderActualiza = false;
					this.agregar = true;
				});
			},
			actualizarDiagnostico: function (padecimiento) {
				this.modal = true;
				this.search = padecimiento.Padecimiento;
				this.evolucion = padecimiento.Evolucion;
				this.idPadActual = padecimiento.idPadActual;
				this.id10 = padecimiento.id10;
				this.nuevodiagnostico = true;
				this.fetchCie(1);
			},
			modificarDiagnostico: function() {
				if(this.Padecimiento == '') {
					this.errores = true;
					return false;
				}
				this.errores = false;
				this.modificar = false;
				this.LoaderActualiza = true;
				this.$http.post('/api/consulta/modificar/diagnostico', {
					IdConsulta: this.idconsulta,
					idPadActual: this.idPadActual,
					IdMedico: this.idmedico,
					IdPaciente: this.idpaciente,
					id10: this.id10,
					Padecimiento: this.Padecimiento,
					Evolucion: this.evolucion,
				})
				.then(function (){
					this.exito = true;
					this.search = '';
					this.evolucion = '';
					this.id10 = '';
					this.modificar = false;
					this.LoaderActualiza = false;
					this.fetchPadecimientos();
					this.closeModal();
				}, function() {
					this.error = true;
					this.LoaderActualiza = false;
				});
			},
			deleteDiagnostico: function(diag) {
				swal({
					title: "Está seguro?",
					text: "El registro será eliminado y enviado a la Papelera de Reciclaje.",
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#DD6B55",
					confirmButtonText: "Si, Continuar!",
					cancelButtonText: "No, cancelar!",
					closeOnConfirm: false,
					closeOnCancel: true,
					showLoaderOnConfirm: true,
				}, function(isConfirm) {
					if (isConfirm) {
						var valuetoken = document.querySelector('#_token').getAttribute('value');
						this.$http.delete('/api/delete/diagnostico/', {
							idPadActual: diag.idPadActual,
							_token: valuetoken,
						})
						.then(function(datos) {
							if(datos.data == 1) {
				            	swal({
				            		title: "Eliminado!",
				            		text: "El Registro se ha enviado a la Papelera de Reciclaje",
				            		type: "success"
				            	});
			            	} else {
			            		swal({
				            		title: "Uppss",
				            		text: "El Registro no pudo ser enviado a la Papelera de Reciclaje",
				            		type: "error"
				            	});
							}
							this.fetchPadecimientos();
						});
					} else {
						swal("Cancelado", "La solicitud ha sido cancelada :)", "error");
					}
				}.bind(this));
			},
			volveracargar: function() {
				this.errorconsulta = false;
				this.firstLoader = true;
				this.fetchPadecimientos();
			},
		},

		computed: {
			Padecimiento: function() {
				return this.search;
			}
		}
	}),

	Vue.component('diagnostico-cie10-lateral', {
		template: '#diagnostico-cie10-lateral',

		props: ['idpaciente', 'idconsulta', 'idmedico'],

		data: function() {
			return {
				listacie: [],
				listadepadecimientos: [],
				listamedicamentos: [],
				evolucion: '',
				id10: '',
				idPadActual: '',
				Padecimiento: '',
				search: '',
				agregar: false,
				agregarpadecimiento: false,
				diagnostico: false,
				errorcarga: false,
				errores: false,
				exito: false,
				Loader: false,
				LoaderActualiza: false,
				Loaderinicio: false,
				modal: false,
				modificar: false,
				mostrarlista: false,
				nuevodiagnostico: false,
			}
		},

		created: function() {
			this.fetchPadecimientos();
		},

		methods: {
			fetchmedicamentos: function() {
				this.$http.get('/api/consulta/medicamentos/' + this.idconsulta, function(lista) {
					this.listamedicamentos = lista;
				})
				.then(function (){
					this.errores = false;
				}, function() {
					this.errores = true;
				});
			},
			fetchPadecimientos: function() {
				this.Loaderinicio = true;
				this.$http.get('/api/consulta/paciente/padecimientos/' + this.idpaciente, function(lista) {
					this.listadepadecimientos = lista;
					if(lista.length > 0) {
						this.diagnostico = true;
					}
				})
				.then(function (){
					this.errores = false;
					this.errorcarga = false;
					this.Loaderinicio = false;
				}, function() {
					this.Loaderinicio = false;
					this.diagnostico = false;
					this.errorcarga = true;
					this.errores = true;
				});
			},
			fetchCie: function(datos) {
				this.Loader = true;
				this.$http.get('/api/consulta/cie', function(cie) {
					this.listacie = cie;
				})
				.then(function (){
					if(datos == 1) {
						this.agregar = false;
					} else {
						this.agregar = true;
					}
					this.Loader = false;
					this.agregarpadecimiento = true;
				}, function() {
					this.Loader = false;
					this.errores = true;
				});
			},
			openModal: function() {
				this.fetchCie();
				this.modificar = false;
				this.search = '';
				this.evolucion = '';
				this.modal = true;
				this.diagnostico = true;
				this.exito = false;
				this.errores = false;
				$('#cie10Diag').garlic(); // local storage
			},
			closemodal: function() {
				this.exito = false;
				this.errores = false;
				this.modal = false;
				this.nuevodiagnostico = false;
				this.agregarpadecimiento = false;
			},
			abrirFormulario: function () {
				this.diagnostico = false;
				this.nuevodiagnostico = true;
			},
			cerrarFormulario: function () {
				this.diagnostico = true;
				this.nuevodiagnostico = false;
			},
			escribeCie: function(cie) {
				this.search = cie.dec10;
				this.id10 = cie.id10;
				this.mostrarlista = false;
			},
			agregarDiagnostico: function(enviar) {
				if(this.Padecimiento == '') {
					this.errores = true;
					return false;
				}
				this.LoaderActualiza = true;
				this.agregar = false;
				this.errores = false;
				if(this.idconsulta == '') { this.idconsulta = null; }
				this.$http.post('/api/consulta/agregar/diagnostico', {
					IdConsulta: this.idconsulta,
					IdMedico: this.idmedico,
					IdPaciente: this.idpaciente,
					id10: this.id10,
					Padecimiento: this.Padecimiento,
					Evolucion: this.evolucion,
				})
				.then(function (){
					this.exito = true;
					this.search = '';
					this.evolucion = '';
					this.id10 = '';
					this.fetchPadecimientos();
					this.LoaderActualiza = false;
					this.agregar = true;
					this.cerrarFormulario();
				}, function() {
					this.LoaderActualiza = false;
					this.error = true;
				});
			},
			actualizarDiagnostico: function (padecimiento) {
				this.modal = true;
				this.agregarpadecimiento = true;
				this.search = padecimiento.Padecimiento;
				this.evolucion = padecimiento.Evolucion;
				this.idPadActual = padecimiento.idPadActual;
				this.id10 = padecimiento.id10;
				this.nuevodiagnostico = true;
				this.agregar = false;
				this.modificar = true;
				this.fetchCie(1);
			},
			modificarDiagnostico: function() {
				if(this.Padecimiento == '') {
					this.errores = true;
					return false;
				}
				this.errores = false;
				this.modificar = false;
				this.LoaderActualiza = true;
				this.$http.post('/api/consulta/modificar/diagnostico', {
					IdConsulta: this.idconsulta,
					idPadActual: this.idPadActual,
					IdMedico: this.idmedico,
					IdPaciente: this.idpaciente,
					id10: this.id10,
					Padecimiento: this.Padecimiento,
					Evolucion: this.evolucion,
				})
				.then(function (){
					this.exito = true;
					this.search = '';
					this.evolucion = '';
					this.id10 = '';
					this.modificar = false;
					this.LoaderActualiza = false;
					this.fetchPadecimientos();
					this.closeModal();
				}, function() {
					this.error = true;
					this.LoaderActualiza = false;
				});
			},
			deleteDiagnostico: function(diag) {
				swal({
					title: "Está seguro?",
					text: "El registro será eliminado y enviado a la Papelera de Reciclaje.",
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#DD6B55",
					confirmButtonText: "Si, Continuar!",
					cancelButtonText: "No, cancelar!",
					closeOnConfirm: false,
					closeOnCancel: true,
					showLoaderOnConfirm: true,
				}, function(isConfirm) {
					if (isConfirm) {
						var valuetoken = document.querySelector('#_token').getAttribute('value');
						this.$http.delete('/api/delete/diagnostico/', {
							idPadActual: diag.idPadActual, _token: valuetoken
						})
						.then(function(datos) {
							if(datos.data == 1) {
				            	swal({
				            		title: "Eliminado!",
				            		text: "El Registro se ha enviado a la Papelera de Reciclaje",
				            		type: "success"
				            	});
			            	} else {
			            		swal({
				            		title: "Uppss",
				            		text: "El Registro no pudo ser enviado a la Papelera de Reciclaje",
				            		type: "error"
				            	});
			            	};
				            this.fetchPadecimientos();
						});
					} else {
						swal("Cancelado", "La solicitud ha sido cancelada :)", "error");
					}
				}.bind(this));
			},
			closeErrores: function() {
				this.errores = false;
			},
			volveraCargar: function() {
				this.fetchPadecimientos();
				this.errorcarga = false;
			},
			changeStatus: function(id, estatus) {
				var estatus = (estatus == 'Activo') ? 'Inactivo' : 'Activo';
				swal({
					title: "Confirmar",
					text: "Desea cambiar el Estatus del Diagnostico?",
					type: "info",
					showCancelButton: true,
					confirmButtonColor: "#DD6B55",
					confirmButtonText: "Si, Continuar!",
					cancelButtonText: "No, cancelar!",
					closeOnConfirm: false,
					closeOnCancel: true,
					showLoaderOnConfirm: true,
				}, function(isConfirm) {
					if (isConfirm) {
						var valuetoken = document.querySelector('#_token').getAttribute('value');
						if(estatus == 'Activo') {
							url = '/api/diagnostico/activar';
						} else {
							url = '/api/diagnostico/desactivar';
						}
						this.$http.post( url, {
							idPadActual: id, _token: valuetoken
						})
						.then(function(datos) {
							if(datos.data == 1) {
				            	swal({
				            		title: "Listo!",
				            		text: "Se ha modificado el Estatus del Diagnostico",
				            		type: "success"
				            	});
			            	} else {
			            		swal({
				            		title: "Uppss",
				            		text: "No se logró cambiar el Estatus del Diagnostico.",
				            		type: "error"
				            	});
			            	};
				            this.fetchPadecimientos();
						});
					} else {
						swal("Cancelado", "La solicitud ha sido cancelada :)", "error");
					}
				}.bind(this));
			},
			cerrarExito: function() {
				this.exito = false;
			},
		},

		computed: {
			Padecimiento: function() {
				return this.search;
			}
		}
	}),

	Vue.component('medicamentos', {

		template: '#medicamentos',

		props: ['idpaciente', 'idconsulta', 'idmedico', 'status'],

		data: function() {
			return {
				search: '',
				errores: false,
				modal: false,
				exito: false,
				agregar: false,
				editar: false,
				mostrarlista: false,
				nuevomedicamento: true,
				Loader: false,
				Consultando: true,
				Medicamento: '',
				Indicaciones: '',
				Duracion: '',
				listamedicamentos: [],
				listageneralmedicamentos: [],
				idmedactual: '',
			}
		},

		created: function() {
			this.fetchMedicamentos();
		},
		methods: {
			fetchMedicamentos: function() {
				this.errores = false;
				this.$http.get('/api/consulta/medicamentos/' + this.idconsulta, function(lista) {
					this.listamedicamentos = lista;
				})
				.then(function (){ }, function() { this.errores = true; });
			},
			fetchListadoGeneralMedicamentos: function(editar) {
				this.Consultando = true;
				this.agregar = false;
				this.$http.get('/api/medicamentos/listado-general', function(lista) {
					this.listageneralmedicamentos = lista;
				})
				.then(function(){
					this.Consultando = false;
					if(editar == 2) {
						this.editar = true;
					} else {
						this.agregar = true;
					}
				});
			},
			openModal: function() {
				this.modal = true;
				this.nuevomedicamento = true;
				this.exito = false;
				this.errores = false;
				this.editar = false;
				this.agregar = false;
				this.fetchListadoGeneralMedicamentos();
			},
			closeModal: function() {
				this.modal = false;
				this.nuevomedicamento = false;
				this.exito = false;
				this.errores = false;
				this.resetValores();
			},
			closeErrores: function() {
				this.errores = false;
			},
			escribeMed: function(med) {
				this.search = med.Medicamento;
				this.mostrarlista = false;
			},
			resetValores: function() {
				this.search = '';
				this.Indicaciones = '';
				this.Medicamento = '';
				this.Duracion = '';
				this.agregar = true;
				this.Loader = false;
				this.Consultando = false;
			},
			agregarMedicamento: function() {
				if(this.Medicamento == '') {
					this.errores = true;
					return false;
				}
				this.agregar = false;
				this.Loader = true;
				this.errores = false;
				this.$http.post('/api/consulta/agregar/medicamento', {
					IdConsulta: this.idconsulta,
					IdMedico: this.idmedico,
					IdPaciente: this.idpaciente,
					Indicaciones: this.Indicaciones,
					Medicamento: this.Medicamento,
					Duracion: this.Duracion,
				})
				.then(function (){
					this.resetValores();
					this.exito = true;
					this.fetchMedicamentos();
				}, function() {
					this.errores = true;
					this.resetValores();
				});
			},
			deleteMedicamento: function(diag) {
				swal({
					title: "Está seguro?",
					text: "El registro será eliminado y enviado a la Papelera de Reciclaje.",
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#DD6B55",
					confirmButtonText: "Si, Continuar!",
					cancelButtonText: "No, cancelar!",
					closeOnConfirm: false,
					closeOnCancel: true,
					showLoaderOnConfirm: true,
				}, function(isConfirm) {
					if (isConfirm) {
						var valuetoken = document.querySelector('#_token').getAttribute('value');
						this.$http.delete('/api/delete/medicamento/', {
							idMedActual: diag.idMedActual,
							_token: valuetoken
						})
						.then(function(datos) {
							if(datos.data == 1) {
				            	swal({
				            		title: "Eliminado!",
				            		text: "El Registro se ha enviado a la Papelera de Reciclaje",
				            		type: "success"
				            	}, function(){
				            	});
			            	} else {
			            		swal({
				            		title: "Uppss",
				            		text: "El Registro no pudo ser enviado a la Papelera de Reciclaje",
				            		type: "error"
				            	});
							};
				        	this.fetchMedicamentos();
						});
					} else {
						swal("Cancelado", "La solicitud ha sido cancelada :)", "error");
					}
				}.bind(this));
			},
			verEdicion: function(medicamento) {
				this.lalista = false;
				this.idmedico = medicamento.IdMedico
				this.idpaciente = medicamento.IdPaciente;
				this.Indicaciones = medicamento.Indicaciones;
				this.idmedactual = medicamento.idMedActual;
				this.Medicamento = medicamento.Medicamento;
				this.search = medicamento.Medicamento;
				this.Duracion = medicamento.Duracion;
				this.agregar = true;
				this.modal = true;
				this.nuevomedicamento = true;
				this.exito = false;
				this.errores = false;
				this.agregar = false;
				this.fetchListadoGeneralMedicamentos(2);
			},
			actualizaMedicamento: function() {
				if(this.Medicamento == '' || this.search == '') {
					this.errores = true;
					return false;
				}
				this.Medicamento = this.search;
				this.agregaMed = false;
				this.editar = false;
				this.Loader = true;
				this.errores = false;
				this.$http.post('/api/consulta/modificar/medicamento', {
					idMedActual: this.idmedactual,
					IdMedico: this.idmedico,
					IdPaciente: this.idpaciente,
					Indicaciones: this.Indicaciones,
					Medicamento: this.Medicamento,
					Duracion: this.Duracion,
				})
				.then(function (){
					this.exito = true;
					this.Loader = false;
					this.agregar = false;
				}, function() {
					this.errores = true;
				});
			},
		},

		computed: {
			Medicamento: function() {
				return this.search;
			}
		},
	});

	Vue.component('medicamentos-activos', {

		template: '#medicamentos-activos',

		props: ['idpaciente', 'idconsulta', 'idmedico'],

		data: function() {
			return {
				agregar: false,
				Consultando: true,
				Duracion: '',
				editar: false,
				errores: false,
				errorcarga: false,
				exito: false,
				latabla: false,
				Loader: false,
				Loaderinicio: true,
				modal: false,
				mostrarlista: false,
				nuevomedicamento: false,
				elpaciente: '',
				idmedactual: '',
				Indicaciones: '',
				Medicamento: '',
				search: '',
				listageneralmedicamentos: [],
				listamedicamentos: [],
			}
		},

		created: function() {
			this.fetchMedicamentos();
			this.fetchPaciente();
		},
		methods: {
			fetchPaciente: function() {
				this.$http.get('/api/nombre-paciente/' + this.idpaciente, function(nombre){
				}.bind(this))
				.then(function (datos){
					this.elpaciente = datos.data.Nombre + ' ' + datos.data.ApellidoPaterno + ' ' + datos.data.ApellidoMaterno;
					this.errores = false;
				}, function() {
					this.errores = true;
				});
			},
			fetchMedicamentos: function() {
				this.$http.get('/api/consulta/paciente/medicamentos/' + this.idpaciente, function(lista) {
					this.listamedicamentos = lista;
				})
				.then(function (){
					this.Loaderinicio = false;
					this.errores = false;
					this.errorcarga = false;
				}, function() {
					this.Loaderinicio = false;
					this.errorcarga = true;
					this.errores = true;
				});
			},
			fetchListadoGeneralMedicamentos: function(editar) {
				this.Consultando = true;
				this.agregar = false;
				this.$http.get('/api/medicamentos/listado-general', function(lista) {
					this.listageneralmedicamentos = lista;
				})
				.then(function(){
					this.Consultando = false;
					if(editar == 2) {
						this.agregar = false;
						this.editar = true;
					} else {
						this.agregar = true;
					}
				});
			},
			openModal: function() {
				this.modal = true;
				this.latabla = true;
				this.exito = false;
				this.errores = false;
				this.fetchPaciente();
				this.fetchListadoGeneralMedicamentos();
			},
			closeModal: function() {
				this.modal = false;
				this.nuevomedicamento = false;
				this.exito = false;
				this.errores = false;
				this.resetValores();
			},
			closeErrores: function() {
				this.errores = false;
			},
			escribeMed: function(med) {
				this.search = med.Medicamento;
				this.mostrarlista = false;
			},
			resetValores: function() {
				this.search = '';
				this.Indicaciones = '';
				this.Medicamento = '';
				this.Duracion = '';
				this.agregar = true;
				this.Loader = false;
				this.Consultando = false;
			},
			agregarMedicamento: function() {
				if(this.Medicamento == '') {
					this.errores = true;
					return false;
				}
				this.agregar = false;
				this.Loader = true;
				this.errores = false;
				this.$http.post('/api/consulta/agregar/medicamento', {
					IdConsulta: this.idconsulta,
					IdMedico: this.idmedico,
					IdPaciente: this.idpaciente,
					Indicaciones: this.Indicaciones,
					Medicamento: this.Medicamento,
					Duracion: this.Duracion,
				})
				.then(function (){
					this.resetValores();
					this.exito = true;
					this.fetchMedicamentos();
				}, function() {
					this.errores = true;
					this.resetValores();
				});
			},
			deleteMedicamento: function(diag) {
				swal({
					title: "Está seguro?",
					text: "El Medicamento será eliminado y enviado a la Papelera de Reciclaje.",
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#DD6B55",
					confirmButtonText: "Si, Continuar!",
					cancelButtonText: "No, cancelar!",
					closeOnConfirm: false,
					closeOnCancel: true,
					showLoaderOnConfirm: true,
				}, function(isConfirm) {
					if (isConfirm) {
						var valuetoken = document.querySelector('#_token').getAttribute('value');
						this.$http.delete('/api/delete/medicamento', {
				            	idMedActual: diag.idMedActual,
								_token: valuetoken
				        })
				        .then(function(datos){
			            	if(datos.data == 1) {
				            	swal({
				            		title: "Eliminado!",
				            		text: "El Registro se ha enviado a la Papelera de Reciclaje",
				            		type: "success"
				            	});
			            	} else {
			            		swal({
				            		title: "Uppss",
				            		text: "El Registro no pudo ser enviado a la Papelera de Reciclaje",
				            		type: "error"
				            	});
			            	}
			            	this.fetchMedicamentos();
			            });
					} else {
						swal("Cancelado", "La solicitud ha sido cancelada :)", "error");
					}
				}.bind(this));
			},
			verEdicion: function(medicamento) {
				this.lalista = false;
				this.idmedico = medicamento.IdMedico
				this.idpaciente = medicamento.IdPaciente;
				this.Indicaciones = medicamento.Indicaciones;
				this.idmedactual = medicamento.idMedActual;
				this.Medicamento = medicamento.Medicamento;
				this.search = medicamento.Medicamento;
				this.Duracion = medicamento.Duracion;
				this.agregar = true;
				this.modal = true;
				this.nuevomedicamento = true;
				this.exito = false;
				this.errores = false;
				this.agregar = false;
				this.fetchListadoGeneralMedicamentos(2);
			},
			actualizaMedicamento: function() {
				if(this.Medicamento == '' || this.search == '') {
					this.errores = true;
					return false;
				}
				this.Medicamento = this.search;
				this.agregaMed = false;
				this.editar = false;
				this.Loader = true;
				this.errores = false;
				if(this.idconsulta == '') {
						this.idconsulta = null;
				};
				this.$http.post('/api/consulta/modificar/medicamento', {
					idMedActual: this.idmedactual,
					IdMedico: this.idmedico,
					IdPaciente: this.idpaciente,
					Indicaciones: this.Indicaciones,
					Medicamento: this.Medicamento,
					Duracion: this.Duracion,
				})
				.then(function (){
					this.exito = true;
					this.Loader = false;
					this.agregar = false;
					this.fetchMedicamentos();
				}, function() {
					this.errores = true;
				});
			},
			actualizarConsulta: function() {
				this.errorcarga = false;
				this.Loaderinicio = true;
				this.fetchMedicamentos();
			},
			mostrarForma: function() {
				this.latabla = false;
				this.nuevomedicamento = true;
			},
			volverLista: function() {
				this.nuevomedicamento = false;
				this.latabla = true;
				this.exito = false;
				this.errores = false;
			},
			editarMedicamento: function(medicamento) {
				this.fetchListadoGeneralMedicamentos(2);
				this.latabla = false;
				this.nuevomedicamento = true;
				this.idmedico = medicamento.IdMedico
				this.idpaciente = medicamento.IdPaciente;
				this.Indicaciones = medicamento.Indicaciones;
				this.idmedactual = medicamento.idMedActual;
				this.Medicamento = medicamento.Medicamento;
				this.search = medicamento.Medicamento;
				this.Duracion = medicamento.Duracion;
			},
		},

		computed: {
			Medicamento: function() {
				return this.search;
			}
		},
	});

	Vue.component('cerrar-consulta', {

		template: '#cerrarConsulta',

		methods: {
			cerrarConsulta: function(diag) {
				swal({
					title: "Está seguro?",
					text: "Al Cerrar la Consulta ya no podrá realizar modifcaciones.",
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#DD6B55",
					confirmButtonText: "Si, Continuar!",
					cancelButtonText: "No, cancelar!",
					closeOnConfirm: false,
					closeOnCancel: true,
					showLoaderOnConfirm: true,
				}, function(isConfirm) {
					if (isConfirm) {
						var valuetoken = document.querySelector('#_token').getAttribute('value');
						$.ajax({
				            url: '/api/consulta/cerrar',
				            type:"POST",
				            async: true,
				            data: { idConsulta: diag, _token: valuetoken }
				        })
				        .done(function(data){
							if(data == 1) {
				            	swal({
				            		title: "Exito!",
				            		text: "La Consulta ha sido Cerrada.",
				            		type: "success"
				            	}, function(){
				            		window.location.reload(true);
				            	});
			            	} else {
			            		swal({
				            		title: "Uppss",
				            		text: "No se pudo Cerrar la Consulta",
				            		type: "error"
				            	});
							};
						});
					} else {
						swal("Cancelado", "Cierre de Consulta Cancelado", "error");
					}
				});
			},
		}
	});

	Vue.component('medicos', {
		template: '#buscarMedicos',

		data: function(){
			return {
				listadomedicos: [],
				search: '',
				mostrar: false
			}
		},

		created: function() {
			this.getListaMedicos();
		},

		methods: {
			selectMedico: function(medicos) {
				this.search = medicos.Nombre + ' ' + medicos.ApellidoPaterno + ' ' + medicos.ApellidoMaterno;
				this.mostrar = false;
			},
			getListaMedicos: function() {
				this.$http.get('/api/lista-medicosnd/', function (medicos){
					this.listadomedicos = medicos;
				})
				.then(function (){
					this.loading = false;
				}, function() {
					this.loading = false;
					this.errores = true;
				});
			},
			mostrarmedicos: function(nombre) {
				this.mostrar = true;
			}
		}
	});

	Vue.component('lista-medicamentos', {

		template: '#lista-medicamentos',

		props: ['idpaciente', 'idmedico'],

		data: function() {
			return {
				agregaMed: false,
				agregar: false,
				Consultando: false,
				editar: false,
				errorcarga: false,
				errores: false,
				lalista: false,
				latabla: false,
				Loader: false,
				Loaderinicio: true,
				loadinglista: false,
				modal: false,
				mostrarlalista: false,
				mostrarlista: false,
				nuevomedicamento: true,
				result: false,
				search: '',
				elpaciente: '',
				listademedicamentos: [],
				listageneralmedicamentos: [],
				Medicamento: '',
				Indicaciones: '',
				Duracion: '',
				idmedactual: '',
				datoelpaciente: '',
			}
		},

		created: function() {
			this.fetchPaciente();
			this.fetchMedicamentosPaciente();
		},

		methods: {
			fetchMedicamentosPaciente: function() {
				this.loadinglista = true;
				this.$http.get('/api/medicamentos/por-paciente/' + this.idpaciente, function(medicamentos) {
					this.listademedicamentos = medicamentos;
				})
				.then(function (){
					this.Loaderinicio = false;
					this.latabla = true;
					this.errorcarga = false;
					this.loadinglista = false;
					this.lalista = true;
					this.errores = false;
				}, function() {
					this.errorcarga = true;
					this.Loaderinicio = false;
					this.errores = true;
				});
			},
			fetchPaciente: function() {
				this.$http.get('/api/nombre-paciente/' + this.idpaciente, function(nombre){
				})
				.then(function (datos){
					this.elpaciente = datos.data.Nombre + ' ' + datos.data.ApellidoPaterno + ' ' + datos.data.ApellidoMaterno;
					this.errores = false;
				}, function() {
					this.errores = true;
				});
			},
			fetchListadoGeneralMedicamentos: function(ev) {
				this.Consultando = true;
				this.$http.get('/api/medicamentos/listado-general', function(lista) {
					this.listageneralmedicamentos = lista;
				})
				.then(function (result){
					if(ev == 1) {
						var result = false;
					} else {
						var result = true;
					}
					this.Consultando = false;
					this.agregaMed = result;
					this.editar = ! result;
				});
			},
			agregarMedicamento: function() {
				this.lalista = false;
				this.agregar = true;
				this.Indicaciones = '';
				this.Medicamento = '';
				this.search = '';
				this.Duracion = '';
				this.fetchListadoGeneralMedicamentos();
			},
			escribeMed: function(med) {
				this.search = med.Medicamento;
				this.Medicamento = med.Medicamento;
				this.mostrarlista = false;
			},
			sumarMedicamento: function() {
				if(this.Medicamento == '' || this.search == '') {
					this.errores = true;
					return false;
				}
				this.Medicamento = this.search;
				this.agregaMed = false;
				this.Loader = true;
				this.errores = false;
				this.$http.post('/api/consulta/agregar/medicamento', {
					IdMedico: this.idmedico,
					IdPaciente: this.idpaciente,
					Indicaciones: this.Indicaciones,
					Medicamento: this.Medicamento,
					Duracion: this.Duracion,
				})
				.then(function (){
					this.exito = true;
					this.Loader = false;
					this.agregar = false;
					this.fetchMedicamentosPaciente();
				}, function() {
					this.errores = true;
				});
			},
			deleteMedicamento: function(diag) {
				swal({
					title: "Está seguro?",
					text: "El Medicamento será eliminado y enviado a la Papelera de Reciclaje.",
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#DD6B55",
					confirmButtonText: "Si, Continuar!",
					cancelButtonText: "No, cancelar!",
					closeOnConfirm: false,
					closeOnCancel: true,
					showLoaderOnConfirm: true,
				}, function(isConfirm) {
					if (isConfirm) {
						var valuetoken = document.querySelector('#_token').getAttribute('value');
						this.$http.delete('/api/delete/medicamento/', {
							idMedActual: diag.idMedActual,
							_token: valuetoken,
						})
						.then(function(datos){
							if(datos.data == 1) {
				            	swal({
				            		title: "Eliminado!",
				            		text: "El Medicamento se ha enviado a la Papelera de Reciclaje",
				            		type: "success"
				            	});
			            	} else {
			            		swal({
				            		title: "Uppss",
				            		text: "El Medicamento no pudo ser enviado a la Papelera de Reciclaje",
				            		type: "error"
				            	});
			            	};
			            	this.fetchMedicamentosPaciente();
						});
					} else {
						swal("Cancelado", "La solicitud ha sido cancelada :)", "error");
					}
				}.bind(this));
			},
			// con esta mostramos el formulario para editar el medicamento seleccionado
			editarMedicamento: function(medicamento) {
				this.fetchListadoGeneralMedicamentos(1);
				this.lalista = false;
				this.idmedico = medicamento.IdMedico
				this.idpaciente = medicamento.IdPaciente;
				this.Indicaciones = medicamento.Indicaciones;
				this.idmedactual = medicamento.idMedActual;
				this.Medicamento = medicamento.Medicamento;
				this.search = medicamento.Medicamento;
				this.Duracion = medicamento.Duracion;
				this.agregar = true;
			},
			// Con esta mandamos actualizar el registro de un medicamento
			actualizaMedicamento: function() {
				if(this.Medicamento == '' || this.search == '') {
					this.errores = true;
					return false;
				}
				this.Medicamento = this.search;
				this.agregaMed = false;
				this.editar = false;
				this.Loader = true;
				this.errores = false;
				this.$http.post('/api/consulta/modificar/medicamento', {
					idMedActual: this.idmedactual,
					IdMedico: this.idmedico,
					IdPaciente: this.idpaciente,
					Indicaciones: this.Indicaciones,
					Medicamento: this.Medicamento,
					Duracion: this.Duracion,
				})
				.then(function (){
					this.exito = true;
					this.Loader = false;
					this.agregar = false;
					this.fetchMedicamentosPaciente();
				}, function() {
					this.errores = true;
				});
			},
			showLista: function() {
				this.agregar = false;
				this.lalista = true;
				this.agregaMed = false;
				this.editar = false;
			},
			openModal: function() {
				this.modal = true;
				this.fetchMedicamentosPaciente();
				$('#medPorPac').garlic(); // local storage
			},
			closeModal: function() {
				this.modal = false;
				this.agregaMed = false;
				this.agregar = false;
				this.editar = false;
				this.Indicaciones = '';
				this.Medicamento = '';
				this.search = '';
				this.Duracion = '';
				this.fetchListadoGeneralMedicamentos();
			},
			actualizarConsulta: function() {
				this.errorcarga = false;
				this.Loaderinicio = true;
				this.fetchPaciente();
				this.fetchMedicamentosPaciente();
			},
		},
	});

	Vue.component('bloquear-agenda', {

		template: '#bloquear-agenda',

		props: ['idmedico', 'iduser', 'medico', 'sociedad'],

		data: function() {
			return {
				submitForm: false,
				modal: false,
				bloqueo: false,
				type: 5,
				tipoConsulta: 1,
				submitform: true,
				stop: '',
				start_hora: 4,
				start_min: 00,
				start_ampm: 'PM',
				stop_hora: 4,
				stop_min: 30,
				stop_ampm: 'PM',
				description: '',
				token: '',
				elmedico: '',
				idmedicofinal: '',
				loader: false,
				Loaderinicio: false,
				errores: false,
				errorcarga: false,
				exito: false,
				mostrarmedico: false,
				nombremedico: true,
				listamedicossociedad: [],
			}
		},

		created: function() {
			if(this.sociedad == undefined) {
				this.idmedicofinal = this.idmedico;
			} else {
				this.nombremedico = false;
				this.idmedicofinal = '';
			}
		},

		methods: {
			getMedicos: function () {
				this.errores = false;
				this.errorcarga = false;
				this.Loaderinicio = true;
				this.mostrarmedico = false;
				this.$http.get('/api/lista-medicos-sociedad/' + this.sociedad, function(medicos) {
					this.listamedicossociedad = medicos;
				})
				.then(function() {
					this.Loaderinicio = false;
					this.aviso = true;
					this.mostrarmedico = true;
				}, function() {
					this.mostrarmedico = false;
					this.aviso = false;
					this.Loaderinicio = false;
					this.errorcarga = true;
				});
			},
			sendBloqueo: function() {
				this.errores = false;
				if(this.sociedad == undefined) {
					this.idmedicofinal = this.idmedico;
				} else {
					this.idmedicofinal = this.elmedico;
				}
				if(this.start == '' || this.idmedico == undefined || this.idmedicofinal == '') {
					this.errores = true;
					return false;
				}
				this.loader = true;
				this.submitform = false;
				const start = $('input#start').val();
				const stop = $('input#stop').val();
				this.$http.post('/api/bloquear-citas', {
					event_title: 'Bloqueo de Espacio',
					start: start,
					stop: stop,
					start_hora: this.start_hora,
					start_min: this.start_min,
					start_ampm: this.start_ampm,
					stop_hora: this.stop_hora,
					stop_min: this.stop_min,
					stop_ampm: this.stop_ampm,
					description: this.description,
					type: this.type,
					IdMedico: this.idmedicofinal,
					Status: 'Abierta',
					tipoConsulta: this.tipoConsulta,
					iduser: this.iduser,
				})
				.then(function (){
					this.exito = true;
					this.loader = false;
					this.submitform = true;
				}, function() {
					this.errores = true;
					this.loader = false;
					this.submitform = true;
				});
			},
			openModal: function() {
				this.modal = true;
				this.bloqueo = true;
				this.submitform = true;
				if(this.sociedad != undefined) {
					this.getMedicos();
				}
			},
			closeModal: function() {
				this.modal = false;
				this.bloqueo = false;
			},
			actualizarConsulta: function() {
				this.getMedicos();
			},
		},
	});

	Vue.component('consultas-parahoy', {
		template: '#consultas-parahoy',

		props: ['idpaciente'],

		data: function() {
			return {
				verificahc: false,
				verificandohc: true,
				volveraverificarhc: true,
				contarcitashoy: 0,
				citashoy: false,
				error: false,
				listacitashoy: [],
			}
		},

		created: function() {
			this.fetchCitasHoy();
			this.validaHC(this.idpaciente);
		},

		methods: {
			fetchCitasHoy: function() {
				this.$http.get('/api/citas/hoy/paciente/' + this.idpaciente, function(data){
					this.listacitashoy = data;
					this.contarcitashoy = data.length;
				})
				.then(function(){
					this.citashoy = true;
					revisarprogreso();
					this.error = false;
				}, function(){
					revisarprogreso();
					this.citashoy = false;
					this.contarcitashoy = 0;
					this.error = true;
				});
			}, // OK
			volveraCargar: function() {
				this.fetchCitasHoy();
			},
			validaHC: function(idpaciente) {
				this.volveraverificarhc = false;
				this.$http.get('/api/hc/paciente/verificar/' + idpaciente, function(data){
					if(data == 1) {
						this.verificahc = false;
					}
					if(data == 0) {
						this.verificahc = true;
					}
				})
				.then(function() {
					this.verificandohc = false;
				}, function() {
					this.verificandohc = false;
					this.volveraverificarhc = true;
				});
			}, // OK
		},
	}); // 5 revisar

	Vue.component('proximas-citas', {
		template: '#proximas-citas',

		props: ['idpaciente'],

		data: function() {
			return {
				citasproximas: false,
				contarcitasproximas: 0,
				listacitasproxima: [],
				error: false,
			}
		},

		created: function() {
			this.fetchCitasProximas();
		},

		methods: {
			fetchCitasProximas: function(){
				this.$http.get('/api/citas/proximas/paciente/'+ this.idpaciente , function (proximas){
					this.listacitasproxima = proximas;
					this.contarcitasproximas = proximas.length;
					this.error = false;
				})
				.then(function (proximas){
					$('[data-toggle="popover"]').popover();
					tareaslistas = tareaslistas++;
					revisarprogreso();
					this.citasproximas = true;
					this.error = false;
				}, function(){
					revisarprogreso();
					this.citasproximas = false;
					this.error = true;
					this.contarcitasproximas = 0;
					this.error = true;
				});
			},
			volveraCargar: function() {
				this.fetchCitasProximas();
			},
		},
	}); // 4 revisar

	Vue.component('show-consultas-previas', {
		template: '#consultas-previas',

		props: ['idpaciente'],

		data: function() {
			return {
				consultasprevias: 0,
				mostrarconsultasprevias: false,
				error: false,
				listaconsultaprevias: [],
			}
		},

		created: function() {
			this.fetchConsultasPrevias();
		},

		methods: {
			fetchConsultasPrevias: function(){
				this.$http.get('/api/consulta/tres-ultimas/previas/paciente/'+ this.idpaciente , function (previas){
					this.listaconsultaprevias = previas;
					this.consultasprevias = previas.length;
				})
				.then(function (previas){
					this.mostrarconsultasprevias = true;
					this.error = false;
					revisarprogreso();
				}, function(){
					revisarprogreso();
					this.mostrarconsultasprevias = false;
					this.consultasprevias = 0;
					this.error = true;
				});
			},
			volveraCargar: function() {
				this.fetchConsultasPrevias();
			},
		},
	}); // 3 revisar

	Vue.component('citas-anteriores', {
		template: '#citas-anteriores',

		props: ['idpaciente'],

		data: function() {
			return {
				citasprevias: false,
				verificahc: true,
				contarcitasprevias: 0,
				error: false,
				listacitasprevias: [],
			}
		},

		created: function() {
			this.fetchCitasPrevias();
			this.validaHC(this.idpaciente);
		},

		methods: {
			fetchCitasPrevias: function(){
				this.$http.get('/api/citas/previas/sin-confirmar/paciente/'+ this.idpaciente , function (previas){
					this.listacitasprevias = previas;
					this.contarcitasprevias = previas.length;
				})
				.then(function (previas){
					this.citasprevias = true;
					this.error = false;
					revisarprogreso();
				}, function(){
					revisarprogreso();
					this.error = true;
					this.citasprevias = false;
					this.contarcitasprevias = false;
				});
				// Activar pop-ups
			},
			volveraCargar: function() {
				this.fetchCitasPrevias();
			},
			validaHC: function(idpaciente) {
				this.$http.get('/api/hc/paciente/verificar/' + idpaciente, function(data){
					if(data == 1) { this.verificahc = false; }
				});
			},
		},
	}); // 2 revisar

	Vue.component('notas-rapidas', {
		template: '#notas-rapidas',

		props: ['idpaciente'],

		data: function() {
			return {
				listanotasrapidas: [],
				contarnotas: 0,
				notas: false,
				error: false,
			}
		},

		created: function() {
			this.searchNotasRapidas();
		},

		methods: {
			searchNotasRapidas: function() {
				this.$http.get('/api/notas/rapidas/'+ this.idpaciente , function (data){
					this.listanotasrapidas = data;
					this.contarnotas = data.length;
				})
				.then(function (){
					this.loading = false;
					this.notas = true;
					this.error = false;
					revisarprogreso();
					this.$dispatch('total-notas', this.contarnotas);
				}, function(){
					this.error = true;
					this.contarnotas = 0;
					this.notas = false;
					revisarprogreso();
				});
			}, // OK
			volveraCargar: function() {
				this.searchNotasRapidas();
			},
			deleteNota: function(nota) {
				swal({
					title: "Está seguro?",
					text: "El registro será eliminado y enviado a la Papelera de Reciclaje.",
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#DD6B55",
					confirmButtonText: "Si, Continuar!",
					cancelButtonText: "No, cancelar!",
					closeOnConfirm: false,
					closeOnCancel: true,
					showLoaderOnConfirm: true,
				}, function(isConfirm) {
					if (isConfirm) {
						var valuetoken = document.querySelector('#_token').getAttribute('value');
						$.ajax({
				            url: '/api/delete/notas/rapidas/',
				            type:"DELETE",
				            async: true,
				            data: { id: nota.idfn, _token: valuetoken }
				        })
				        .done(function(data){
							if(data == 1) {
				            	swal({
				            		title: "Eliminado!",
				            		text: "El Registro se ha enviado a la Papelera de Reciclaje",
				            		type: "success"
				            	}, function(){
				            		window.location.reload(true);
				            	});
			            	} else {
			            		swal({
				            		title: "Uppss",
				            		text: "El Registro no pudo ser enviado a la Papelera de Reciclaje",
				            		type: "error"
				            	});
							};
						});
					} else {
						swal("Cancelado", "La solicitud ha sido cancelada :)", "error");
					}
				});
			}, // OK
		},
	}); // 1 revisar

	Vue.component('heredo-familiares', {

		template: '#heredo-familiares',

		props: ['idpaciente'],

		data: function() {
			return {
				Generales: '',
				Paternos: '',
				Maternos: '',
				Hermanos: '',
				Hijos: '',
				Otros: '',
				Observaciones: '',
				idAntecedentes: '',
				modal: false,
				formulario: false,
				guardar: false,
				exito: false,
				errores: false,
				Loader: false,
				Loaderinicio: true,
				antecedentes: false,
				mostrarboton: false,
				botoneditar: false,
				errorconsulta: false,
			}
		},

		created: function() {
			this.getListadoAntecedentes(this.idpaciente);
		},

		methods: {
			getListadoAntecedentes: function(idpaciente) {
				this.errorconsulta = false;
				this.$http.get('/api/lista/antecedentes/familiares/' + idpaciente, function(data) {
					this.antecedentes = data;
					this.idAntecedentes = data.idAntecedentes;
				})
				.then(function(){
					if(this.antecedentes != 0) {
						this.mostrarboton = false;
					} else {
						this.mostrarboton = true;
					}
					this.Loaderinicio = false;
				}, function(){
					this.Loaderinicio = false;
					this.listaerror = true;
					this.antecedentes = false;
					this.errorconsulta = true;
				});
			},
			guardarRegistro: function() {
				this.guardar = false;
				this.Loader = true;
				this.errores = false;
				this.$http.post('/api/registrar/antecedentes/familiares', {
					idPaciente: this.idpaciente,
					Generales: this.Generales,
					Paternos: this.Paternos,
					Maternos: this.Maternos,
					Hermanos: this.Hermanos,
					Hijos: this.Hijos,
					Otros: this.Otros,
					Observaciones: this.Observaciones,
				})
				.then(function (){
					this.resetValores();
					this.Loader = false;
					this.formulario = false;
					this.exito = true;
				}, function() {
					this.Loader = false;
					this.guardar = true;
					this.errores = true;
				});
			},
			showEditar: function(general) {
				this.modal = true;
				this.Generales = general.Generales;
				this.Paternos = general.Paternos;
				this.Maternos = general.Maternos;
				this.Hermanos = general.Hermanos;
				this.Hijos = general.Hijos;
				this.Otros = general.Otros;
				this.Observaciones = general.Observaciones;
				this.formulario = true;
				this.botoneditar = true;
			},
			actualizarRegistro: function() {
				this.Loader = true;
				this.botoneditar = false;
				this.$http.post('/api/actualizar/antecedentes/familiares', {
					idPaciente: this.idpaciente,
					idAntecedentes: this.idAntecedentes,
					Generales: this.Generales,
					Paternos: this.Paternos,
					Maternos: this.Maternos,
					Hermanos: this.Hermanos,
					Hijos: this.Hijos,
					Otros: this.Otros,
					Observaciones: this.Observaciones,
				})
				.then(function (){
					this.resetValores();
					this.Loader = false;
					this.formulario = false;
					this.exito = true;
				}, function() {
					this.Loader = false;
					this.botoneditar = true;
					this.errores = true;
				});
			},
			resetValores: function() {
				this.Generales = '';
				this.Paternos = '';
				this.Maternos = '';
				this.Hermanos = '';
				this.Hijos = '';
				this.Otros = '';
				this.Observaciones = '';
			},
			closeErrores: function() {
				this.errores = false;
			},
			openModal: function() {
				this.modal = true;
				this.formulario = true;
				this.guardar = true;
				$("#heredoFamiliares").garlic(); // local storage
			},
			closeModal: function() {
				this.modal = false;
				this.formulario = false;
				this.guardar = false;
				this.Loader = false;
				this.exito = false;
				this.getListadoAntecedentes(this.idpaciente);

			},
			actualizarConsulta: function() {
				this.Loaderinicio = true;
				this.getListadoAntecedentes(this.idpaciente);
			},
		},
	});

	Vue.component('antecedentes-patologicos', {

		template: '#antecedentes-patologicos',

		props: ['idpaciente'],

		data: function() {
			return {
				EnfInfancia: '',
				Alergicos: '',
				Quirurgicos: '',
				AntMedicos: '',
				Infecciosos: '',
				Transfusionales: '',
				Traumaticos: '',
				Hospitalizaciones: '',
				Otros: '',
				Observaciones: '',
				idAntecedentes: '',
				modal: false,
				formulario: false,
				guardar: false,
				exito: false,
				errores: false,
				Loader: false,
				LoaderInicio: true,
				antecedentes: false,
				mostrarboton: false,
				botoneditar: false,
				errorconsulta: false,
			}
		},

		created: function() {
			this.getListadoAntecedentes(this.idpaciente);
		},

		methods: {
			getListadoAntecedentes: function(idpaciente) {
				this.errorconsulta = false;
				this.$http.get('/api/lista/antecedentes/patologicos/' + idpaciente, function(data) {
					this.antecedentes = data;
					this.idAntecedentes = data.idAntecedentes;
				})
				.then(function(){
					if(this.antecedentes != 0) {
						this.mostrarboton = false;
					} else {
						this.mostrarboton = true;
					}
				}, function(){
					this.listaerror = true;
					this.antecedentes = false;
					this.errorconsulta = true;
				});
				this.LoaderInicio = false;
			},
			guardarRegistro: function() {
				this.guardar = false;
				this.Loader = true;
				this.errores = false;
				this.$http.post('/api/registrar/antecedentes/patologicos', {
					idPaciente: this.idpaciente,
					EnfInfancia: this.EnfInfancia,
					Alergicos: this.Alergicos,
					Quirurgicos: this.Quirurgicos,
					AntMedicos: this.AntMedicos,
					Infecciosos: this.Infecciosos,
					Transfusionales: this.Transfusionales,
					Traumaticos: this.Traumaticos,
					Hospitalizaciones: this.Hospitalizaciones,
					Otros: this.Otros,
					Observaciones: this.Observaciones,
				})
				.then(function (){
					this.resetValores();
					this.Loader = false;
					this.formulario = false;
					this.exito = true;
				}, function() {
					this.Loader = false;
					this.guardar = true;
					this.errores = true;
				});
			},
			showEditar: function(general) {
				this.modal = true;
				this.EnfInfancia = general.EnfInfancia;
				this.Alergicos = general.Alergicos;
				this.Quirurgicos = general.Quirurgicos;
				this.AntMedicos = general.AntMedicos;
				this.Infecciosos = general.Infecciosos;
				this.Transfusionales = general.Transfusionales;
				this.Traumaticos = general.Traumaticos;
				this.Hospitalizaciones = general.Hospitalizaciones;
				this.Otros = general.Otros;
				this.Observaciones = general.Observaciones;
				this.formulario = true;
				this.botoneditar = true;
			},
			actualizarRegistro: function() {
				this.Loader = true;
				this.botoneditar = false;
				this.$http.post('/api/actualizar/antecedentes/patologicos', {
					idPaciente: this.idpaciente,
					idAntecedentes: this.idAntecedentes,
					EnfInfancia: this.EnfInfancia,
					Alergicos: this.Alergicos,
					Quirurgicos: this.Quirurgicos,
					AntMedicos: this.AntMedicos,
					Infecciosos: this.Infecciosos,
					Transfusionales: this.Transfusionales,
					Traumaticos: this.Traumaticos,
					Hospitalizaciones: this.Hospitalizaciones,
					Otros: this.Otros,
					Observaciones: this.Observaciones,
				})
				.then(function (){
					this.resetValores();
					this.Loader = false;
					this.formulario = false;
					this.exito = true;
				}, function() {
					this.Loader = false;
					this.botoneditar = true;
					this.errores = true;
				});
			},
			resetValores: function() {
				this.Generales = '';
				this.Paternos = '';
				this.Maternos = '';
				this.Hermanos = '';
				this.Hijos = '';
				this.Otros = '';
				this.Observaciones = '';
			},
			closeErrores: function() {
				this.errores = false;
			},
			openModal: function() {
				this.modal = true;
				this.formulario = true;
				this.guardar = true;
				$("#antPatol").garlic(); // local storage
			},
			closeModal: function() {
				this.modal = false;
				this.formulario = false;
				this.guardar = false;
				this.Loader = false;
				this.exito = false;
				this.getListadoAntecedentes(this.idpaciente);
			},
			actualizarConsulta: function() {
				this.LoaderInicio = true;
				this.getListadoAntecedentes(this.idpaciente);
			},
		},
	});

	Vue.component('antecedentes-no-patologicos', {

		template: '#antecedentes-no-patologicos',

		props: ['idpaciente'],

		data: function() {
			return {
				Tabaquismo: '',
				Alcohol: '',
				Drogas: '',
				Ejercicio: '',
				Otros: '',
				Observaciones: '',
				idAntecedentes: '',
				modal: false,
				formulario: false,
				guardar: false,
				exito: false,
				errores: false,
				Loader: false,
				LoaderInicio: true,
				antecedentes: false,
				mostrarboton: false,
				botoneditar: false,
				errorconsulta: false,
			}
		},

		created: function() {
			this.getListadoAntecedentes(this.idpaciente);
		},

		methods: {
			getListadoAntecedentes: function(idpaciente) {
				this.errorconsulta = false;
				this.$http.get('/api/lista/antecedentes/no-patologicos/' + idpaciente, function(data) {
					this.antecedentes = data;
					this.idAntecedentes = data.idAntecedentes;
				})
				.then(function(){
					if(this.antecedentes != 0) {
						this.mostrarboton = false;
					} else {
						this.mostrarboton = true;
					}
					this.LoaderInicio = false;
				}, function(){
					this.LoaderInicio = false;
					this.listaerror = true;
					this.antecedentes = false;
					this.errorconsulta = true;
				});
			},
			guardarRegistro: function() {
				this.guardar = false;
				this.Loader = true;
				this.errores = false;
				this.$http.post('/api/registrar/antecedentes/no-patologicos', {
					idPaciente: this.idpaciente,
					Tabaquismo: this.Tabaquismo,
					Alcohol: this.Alcohol,
					Drogas: this.Drogas,
					Ejercicio: this.Ejercicio,
					Otros: this.Otros,
					Observaciones: this.Observaciones,
				})
				.then(function (){
					this.resetValores();
					this.Loader = false;
					this.formulario = false;
					this.exito = true;
				}, function() {
					this.Loader = false;
					this.guardar = true;
					this.errores = true;
				});
			},
			showEditar: function(general) {
				this.modal = true;
				this.Tabaquismo = general.Tabaquismo;
				this.Alcohol = general.Alcohol;
				this.Drogas = general.Drogas;
				this.Ejercicio = general.Ejercicio;
				this.Otros = general.Otros;
				this.Observaciones = general.Observaciones;
				this.formulario = true;
				this.botoneditar = true;
			},
			actualizarRegistro: function() {
				this.Loader = true;
				this.botoneditar = false;
				this.$http.post('/api/actualizar/antecedentes/no-patologicos', {
					idPaciente: this.idpaciente,
					idAntecedentes: this.idAntecedentes,
					Tabaquismo: this.Tabaquismo,
					Alcohol: this.Alcohol,
					Drogas: this.Drogas,
					Ejercicio: this.Ejercicio,
					Otros: this.Otros,
					Observaciones: this.Observaciones,
				})
				.then(function (){
					this.resetValores();
					this.Loader = false;
					this.formulario = false;
					this.exito = true;
				}, function() {
					this.Loader = false;
					this.botoneditar = true;
					this.errores = true;
				});
			},
			resetValores: function() {
				this.Generales = '';
				this.Paternos = '';
				this.Maternos = '';
				this.Hermanos = '';
				this.Hijos = '';
				this.Otros = '';
				this.Observaciones = '';
			},
			closeErrores: function() {
				this.errores = false;
			},
			openModal: function() {
				this.modal = true;
				this.formulario = true;
				this.guardar = true;
				$("#antNopat").garlic(); // local storage
			},
			closeModal: function() {
				this.modal = false;
				this.formulario = false;
				this.guardar = false;
				this.Loader = false;
				this.exito = false;
				this.getListadoAntecedentes(this.idpaciente);
			},
			actualizarConsulta: function() {
				this.LoaderInicio = true;
				this.getListadoAntecedentes(this.idpaciente);
			},
		},
	});

	Vue.component('antecedentes-perinatales', {

		template: '#antecedentes-perinatales',

		props: ['idpaciente'],

		data: function() {
			return {
				ControlPrenatal: '',
				TipoParto: '',
				Clasificacion: '',
				SemanasEmbarazo: '',
				LugarNacimiento: '',
				Peso: '',
				Talla: '',
				CircCefalica: '',
				Apgar1: '',
				Apgar5: '',
				Reanimacion: '',
				Complicaciones: '',
				Observaciones: '',
				idAntecedenteP: '',
				modal: false,
				formulario: false,
				guardar: false,
				exito: false,
				errores: false,
				Loader: false,
				LoaderInicio: true,
				antecedentes: false,
				mostrarboton: false,
				botoneditar: false,
				errorconsulta: false,
			}
		},

		created: function() {
			this.getListadoAntecedentes(this.idpaciente);
		},

		methods: {
			getListadoAntecedentes: function(idpaciente) {
				this.errorconsulta = false;
				this.$http.get('/api/lista/antecedentes/perinatales/' + idpaciente, function(data) {
					this.antecedentes = data;
					this.idAntecedentes = data.idAntecedentes;
				})
				.then(function(){
					if(this.antecedentes != 0) {
						this.mostrarboton = false;
					} else {
						this.mostrarboton = true;
					}
					this.LoaderInicio = false;
				}, function(){
					this.LoaderInicio = false;
					this.listaerror = true;
					this.antecedentes = false;
					this.errorconsulta = true;
				});
			},
			guardarRegistro: function() {
				this.guardar = false;
				this.Loader = true;
				this.errores = false;
				this.$http.post('/api/registrar/antecedentes/perinatales', {
					idPaciente: this.idpaciente,
					ControlPrenatal: this.ControlPrenatal,
					TipoParto: this.TipoParto,
					Clasificacion: this.Clasificacion,
					SemanasEmbarazo: this.SemanasEmbarazo,
					LugarNacimiento: this.LugarNacimiento,
					Peso: this.Peso,
					Talla: this.Talla,
					CircCefalica: this.CircCefalica,
					Apgar1: this.Apgar1,
					Apgar5: this.Apgar5,
					Reanimacion: this.Reanimacion,
					Complicaciones: this.Complicaciones,
					Observaciones: this.Observaciones,
				})
				.then(function (){
					this.resetValores();
					this.Loader = false;
					this.formulario = false;
					this.exito = true;
				}, function() {
					this.Loader = false;
					this.guardar = true;
					this.errores = true;
				});
			},
			showEditar: function(general) {
				this.modal = true;
				this.formulario = true;
				this.botoneditar = true;
				this.idAntecedenteP = general.idAntecedenteP;
				this.ControlPrenatal = general.ControlPrenatal;
				this.TipoParto = general.TipoParto;
				this.Clasificacion = general.Clasificacion;
				this.SemanasEmbarazo = general.SemanasEmbarazo;
				this.LugarNacimiento = general.LugarNacimiento;
				this.Peso = general.Peso;
				this.Talla = general.Talla;
				this.CircCefalica = general.CircCefalica;
				this.Apgar1 = general.Apgar1;
				this.Apgar5 = general.Apgar5;
				this.Reanimacion = general.Reanimacion;
				this.Complicaciones = general.Complicaciones;
				this.Observaciones = general.Observaciones;
			},
			actualizarRegistro: function() {
				this.Loader = true;
				this.botoneditar = false;
				this.$http.post('/api/actualizar/antecedentes/perinatales', {
					idPaciente: this.idpaciente,
					idAntecedenteP: this.idAntecedenteP,
					ControlPrenatal: this.ControlPrenatal,
					TipoParto: this.TipoParto,
					Clasificacion: this.Clasificacion,
					SemanasEmbarazo: this.SemanasEmbarazo,
					LugarNacimiento: this.LugarNacimiento,
					Peso: this.Peso,
					Talla: this.Talla,
					CircCefalica: this.CircCefalica,
					Apgar1: this.Apgar1,
					Apgar5: this.Apgar5,
					Reanimacion: this.Reanimacion,
					Complicaciones: this.Complicaciones,
					Observaciones: this.Observaciones,
				})
				.then(function (){
					this.resetValores();
					this.Loader = false;
					this.formulario = false;
					this.exito = true;
				}, function() {
					this.Loader = false;
					this.botoneditar = true;
					this.errores = true;
				});
			},
			resetValores: function() {
				this.ControlPrenatal = '';
				this.TipoParto = '';
				this.Clasificacion = '';
				this.SemanasEmbarazo = '';
				this.LugarNacimiento = '';
				this.Peso = '';
				this.Talla = '';
				this.CircCefalica = '';
				this.Apgar1 = '';
				this.Apgar5 = '';
				this.Reanimacion = '';
				this.Complicaciones = '';
				this.Observaciones = '';
			},
			closeErrores: function() {
				this.errores = false;
			},
			openModal: function() {
				this.modal = true;
				this.formulario = true;
				this.guardar = true;
				$("#formaConsulta").garlic(); // local storage
			},
			closeModal: function() {
				this.modal = false;
				this.formulario = false;
				this.guardar = false;
				this.Loader = false;
				this.exito = false;
				this.getListadoAntecedentes(this.idpaciente);
			},
			actualizarConsulta: function() {
				this.LoaderInicio = true;
				this.getListadoAntecedentes(this.idpaciente);
			},
		},
	});

	Vue.component('exploracion-fisica', {

		template: '#exploracion-fisica',

		props: ['idpaciente', 'idmedico'],

		data: function() {
			return {
				TASistolitica: '',
				TADiastolitica: '',
				FrecuenciaCardiaca: '',
				FrecuenciaRespiratoria: '',
				SaturacionO2: '',
				Peso: '',
				Talla: '',
				Temperatura: '',
				ExpFisica: '',
				Imc: '',
				idExpFis: '',
				modal: false,
				formulario: false,
				guardar: false,
				exito: false,
				errores: false,
				Loader: false,
				LoaderInicio: true,
				antecedentes: false,
				mostrarboton: false,
				botoneditar: false,
				errorconsulta: false,
			}
		},

		created: function() {
			this.getListadoAntecedentes(this.idpaciente);
		},

		methods: {
			getListadoAntecedentes: function(idpaciente) {
				this.errorconsulta = false;
				this.$http.get('/api/lista/antecedentes/exploracion/' + idpaciente, function(data) {
					this.antecedentes = data;
					this.idAntecedentes = data.idAntecedentes;
				})
				.then(function(){
					if(this.antecedentes != 0) {
						this.mostrarboton = false;
					} else {
						this.mostrarboton = true;
					}
					this.LoaderInicio = false;
				}, function(){
					this.mostrarboton = false;
					this.LoaderInicio = false;
					this.listaerror = true;
					this.antecedentes = false;
					this.errorconsulta = true;
				});
			},
			guardarRegistro: function() {
				this.guardar = false;
				this.Loader = true;
				this.errores = false;
				this.$http.post('/api/registrar/antecedentes/exploracion', {
					IdPaciente: this.idpaciente,
					IdMedico: this.idmedico,
					TASistolitica: this.TASistolitica,
					TADiastolitica: this.TADiastolitica,
					FrecuenciaCardiaca: this.FrecuenciaCardiaca,
					FrecuenciaRespiratoria: this.FrecuenciaRespiratoria,
					SaturacionO2: this.SaturacionO2,
					Peso: this.Peso,
					Talla: this.Talla,
					Temperatura: this.Temperatura,
					ExpFisica: this.ExpFisica,
					Imc: this.Imc,
				})
				.then(function (){
					this.resetValores();
					this.Loader = false;
					this.formulario = false;
					this.exito = true;
				}, function() {
					this.Loader = false;
					this.guardar = true;
					this.errores = true;
				});
			},
			showEditar: function(general) {
				this.modal = true;
				this.formulario = true;
				this.botoneditar = true;
				this.idExpFis = general.idExpFis;
				this.TASistolitica = general.TASistolitica;
				this.TADiastolitica = general.TADiastolitica;
				this.FrecuenciaCardiaca = general.FrecuenciaCardiaca;
				this.FrecuenciaRespiratoria = general.FrecuenciaRespiratoria;
				this.SaturacionO2 = general.SaturacionO2;
				this.Peso = general.Peso;
				this.Talla = general.Talla;
				this.Temperatura = general.Temperatura;
				this.ExpFisica = general.ExpFisica;
				this.Imc = general.Imc;			},
			actualizarRegistro: function() {
				this.Loader = true;
				this.botoneditar = false;
				this.$http.post('/api/actualizar/antecedentes/exploracion', {
					IdPaciente: this.idpaciente,
					IdMedico: this.idmedico,
					idExpFis: this.idExpFis,
					TASistolitica: this.TASistolitica,
					TADiastolitica: this.TADiastolitica,
					FrecuenciaCardiaca: this.FrecuenciaCardiaca,
					FrecuenciaRespiratoria: this.FrecuenciaRespiratoria,
					SaturacionO2: this.SaturacionO2,
					Peso: this.Peso,
					Talla: this.Talla,
					Temperatura: this.Temperatura,
					ExpFisica: this.ExpFisica,
					Imc: this.Imc,
				})
				.then(function (){
					this.resetValores();
					this.Loader = false;
					this.formulario = false;
					this.exito = true;
				}, function() {
					this.Loader = false;
					this.botoneditar = true;
					this.errores = true;
				});
			},
			resetValores: function() {
				this.TASistolitica = '';
				this.TADiastolitica = '';
				this.FrecuenciaCardiaca = '';
				this.FrecuenciaRespiratoria = '';
				this.SaturacionO2 = '';
				this.Peso = '';
				this.Talla = '';
				this.Temperatura = '';
				this.ExpFisica = '';
				this.Imc = '';
			},
			closeErrores: function() {
				this.errores = false;
			},
			openModal: function() {
				this.modal = true;
				this.formulario = true;
				this.guardar = true;
				$("#formaConsulta").garlic(); // local storage
			},
			closeModal: function() {
				this.modal = false;
				this.formulario = false;
				this.guardar = false;
				this.Loader = false;
				this.exito = false;
				this.getListadoAntecedentes(this.idpaciente);
			},
			actualizarConsulta: function() {
				this.LoaderInicio = true;
				this.getListadoAntecedentes(this.idpaciente);
			},
		},
	});

	Vue.component('hc-notas', {

		template: '#hc-notas',

		props: ['idpaciente', 'idmedico', 'idconsulta'],

		data: function() {
			return {
				lanota: [],
				idNote: null,
				hcnotasformulario: false,
				Loader: false,
				firstLoader: false,
				submitNotas: false,
				botoneditar: false,
				cancelaredicion: false,
				capturanota: false,
				errorconsulta: false,
				errores: false,
				exito: false,
				mostrarlanota: false,
				botonleyenda: 'Capturar Nota',
				NotasHC: '',
			}
		},

		created: function() {
			this.getListadoNotas(this.idpaciente);
		},

		methods: {
			getListadoNotas: function(idpaciente) {
				this.firstLoader = true;
				this.errores = false;
				this.errorconsulta = false;
				this.botoneditar = false;
				this.cancelaredicion = false;
				this.$http.get('/api/lista/antecedentes/notas-hc/' + idpaciente, function(data) {
					this.NotasHC = data.NotasHC;
				})
				.then(function(datos){
					this.firstLoader = false;
					if(datos.data != 0 && datos.data != null && datos.data != '') {
						this.capturanota = false;
						this.mostrarlanota = true;
						this.idNote = datos.idNote;
						console.log('El id Note: ' + this.idNote);
					} else {
						this.capturanota = true;
					}
				}, function(){
					this.firstLoader = false;
					this.errorconsulta = true;
				});
			},
			toggleNota: function(leyenda) {
				if(leyenda != 'Capturar Nota') {
					this.botonleyenda = 'Capturar Nota';
					this.hcnotasformulario = false;
				} else {
					this.botonleyenda = 'Cerrar Formulario';
					this.hcnotasformulario = true;
					this.submitNotas = true;
				}
				this.Loader = false;
				$("#hcNotas").garlic(); // local storage
			},
			resetValores: function() {
				this.idconsulta = '';
				this.idmedico = '';
				this.idpaciente = '';
				this.NotasHC = '';
			},
			addNotasHC: function() {
				if(this.NotasHC == '') {
					this.errores = true;
				} else {
					if(this.idconsulta == '') { this.idconsulta = null; }
					this.submitNotas = false;
					this.Loader = true;
					this.$http.post('/api/registrar/antecedentes/notas-hc', {
						IdConsulta: this.idconsulta,
						IdMedico: this.idmedico,
						idPaciente: this.idpaciente,
						NotasHC: this.NotasHC,
					})
					.then(function (){
						this.getListadoNotas(this.idpaciente);
						this.Loader = false;
						this.hcnotasformulario = false;
					}, function() {
						this.Loader = false;
						this.hcnotasformulario = true;
						this.errores = true;
					});
				}
			},
			editarNota: function(lanota) {
				this.hcnotasformulario = true;
				this.botoneditar = true;
				this.cancelaredicion = true;
				this.mostrarlanota = false;
			},
			editaNotasHC: function() {
				this.Loader = true;
				this.botoneditar = false;
				this.cancelaredicion = false;
				this.$http.post('/api/actualizar/antecedentes/notas-hc', {
					idNote: this.idNote,
					IdConsulta: this.idconsulta,
					IdMedico: this.idmedico,
					idPaciente: this.idpaciente,
					NotasHC: this.NotasHC,
				})
				.then(function (){
					this.Loader = false;
					this.hcnotasformulario = false;
					this.getListadoNotas(this.idpaciente);
				}, function() {
					this.Loader = false;
					this.botoneditar = true;
					this.cancelaredicion = true;
					this.errores = true;
				});
			},
			volveracargar: function() {
				this.getListadoNotas(this.idpaciente);
			},
			cancelar: function() {
				this.hcnotasformulario = false;
				this.botoneditar = false;
				this.cancelaredicion = false;
				this.mostrarlanota = true;
			},
		},
	});

	Vue.component('alergias-lateral', {
		template: '#alergias-lateral',

		props: ['idpaciente'],

		data: function() {
			return {
				Loader: true,
				errorencarga: false,
				listadoalergias: [],
				showlistadoalergias: false,
				shownolistadoalergias: false,
			}
		},

		created: function() {
			this.findAlergias(this.idpaciente);
		},

		methods: {
			findAlergias: function(idpaciente) {
				this.$http.get('/api/lista/alergias/' + idpaciente, function(data) {
					this.listadoalergias = data;
					if(data.length > 0) {
						this.showlistadoalergias = true;
					} else {
						this.shownolistaalergias = true;
					}
				})
				.then(function(){
					this.Loader = false;
					this.errorencarga = false;
				}, function(){
					this.Loader = false;
					this.errorencarga = true;
				});
			},
			volveracargar: function() {
				this.Loader = true;
				this.errorencarga = false;
				this.findAlergias(this.idpaciente);
			},
		},
	});

	Vue.component('interrogatorio-aparatos', {

		template: '#interrogatorio-aparatos',

		props: ['idpaciente', 'idconsulta', 'idmedico'],

		data: function() {
			return {
				Digestivo: '',
				Cardiovascular: '',
				Respiratorio: '',
				Urinario: '',
				Genital: '',
				Hematologico: '',
				Endocrino: '',
				Osteomuscular: '',
				Nervioso: '',
				Sensorial: '',
				Psicosomatico: '',
				idIntApaSis: '',
				modal: false,
				formulario: false,
				guardar: false,
				exito: false,
				errores: false,
				Loader: false,
				Loaderinicio: false,
				antecedentes: false,
				mostrarboton: false,
				botoneditar: false,
				errorcarga: false,
			}
		},

		created: function() {
			this.getListadoInterrogatorio(this.idpaciente);
		},

		methods: {
			getListadoInterrogatorio: function(idpaciente) {
				this.errorcarga = false;
				this.Loaderinicio = true;
				this.$http.get('/api/lista/interrogatorio/' + idpaciente, function(data) {
					this.antecedentes = data;
					this.idAntecedentes = data.idAntecedentes;
				})
				.then(function(){
					if(this.antecedentes != 0) {
						this.mostrarboton = false;
					} else {
						this.mostrarboton = true;
					}
					this.Loaderinicio = false;
				}, function(){
					this.listaerror = true;
					this.antecedentes = false;
					this.errorcarga = true;
					this.Loaderinicio = false;
				});
			},
			clearRecords: function() {
				this.Digestivo = '';
				this.Cardiovascular = '';
				this.Respiratorio = '';
				this.Urinario = '';
				this.Genital = '';
				this.Hematologico = '';
				this.Endocrino = '';
				this.Osteomuscular = '';
				this.Nervioso = '';
				this.Sensorial = '';
				this.Psicosomatico = '';
			},
			guardarRegistro: function() {
				this.guardar = false;
				this.Loader = true;
				this.errores = false;
				if(this.idconsulta == '') { this.idconsulta = null; };
				this.$http.post('/api/registrar/interrogatorio', {
					IdPaciente: this.idpaciente,
					IdConsulta: this.idconsulta,
					IdMedico: this.idmedico,
					Digestivo: this.Digestivo,
					Cardiovascular: this.Cardiovascular,
					Respiratorio: this.Respiratorio,
					Urinario: this.Urinario,
					Genital: this.Genital,
					Hematologico: this.Hematologico,
					Endocrino: this.Endocrino,
					Osteomuscular: this.Osteomuscular,
					Nervioso: this.Nervioso,
					Sensorial: this.Sensorial,
					Psicosomatico: this.Psicosomatico,
				})
				.then(function (){
					this.clearRecords();
					this.Loader = false;
					this.formulario = false;
					this.exito = true;
				}, function() {
					this.Loader = false;
					this.guardar = true;
					this.errores = true;
				});
			},
			showEditar: function(general) {
				this.modal = true;
				this.idIntApaSis = general.idIntApaSis;
				this.idpaciente = general.IdPaciente;
				this.idconsulta = general.IdConsulta;
				this.idmedico = general.IdMedico;
				this.Digestivo = general.Digestivo;
				this.Cardiovascular = general.Cardiovascular;
				this.Respiratorio = general.Respiratorio;
				this.Urinario = general.Urinario;
				this.Genital = general.Genital;
				this.Hematologico = general.Hematologico;
				this.Endocrino = general.Endocrino;
				this.Osteomuscular = general.Osteomuscular;
				this.Nervioso = general.Nervioso;
				this.Sensorial = general.Sensorial;
				this.Psicosomatico = general.Psicosomatico;
				this.formulario = true;
				this.botoneditar = true;
				$('[rel="tooltip"]').tooltip();
			},
			actualizarRegistro: function() {
				this.Loader = true;
				this.botoneditar = false;
				this.$http.post('/api/actualizar/interrogatorio', {
					idIntApaSis: this.idIntApaSis,
					IdPaciente: this.idpaciente,
					IdConsulta: this.idconsulta,
					IdMedico: this.idmedico,
					Digestivo: this.Digestivo,
					Cardiovascular: this.Cardiovascular,
					Respiratorio: this.Respiratorio,
					Urinario: this.Urinario,
					Genital: this.Genital,
					Hematologico: this.Hematologico,
					Endocrino: this.Endocrino,
					Osteomuscular: this.Osteomuscular,
					Nervioso: this.Nervioso,
					Sensorial: this.Sensorial,
					Psicosomatico: this.Psicosomatico,
				})
				.then(function (){
					this.clearRecords();
					this.Loader = false;
					this.formulario = false;
					this.exito = true;
				}, function() {
					this.Loader = false;
					this.botoneditar = true;
					this.errores = true;
				});
			},
			closeErrores: function() {
				this.errores = false;
			},
			openModal: function() {
				this.modal = true;
				this.formulario = true;
				this.guardar = true;
				$('[rel="tooltip"]').tooltip();
				$('#interrogAparatos').garlic(); // local storage
			},
			closeModal: function() {
				this.modal = false;
				this.formulario = false;
				this.guardar = false;
				this.Loader = false;
				this.exito = false;
				this.getListadoInterrogatorio(this.idpaciente);
			},
			actualizarConsulta: function() {
				this.getListadoInterrogatorio(this.idpaciente);
			},
		},
	});

	Vue.component('documentos', {
		template: '#vue-documentos',

		props: ['idpaciente', 'idusr'],

		data: function() {
			return {
				modal: false,
				Loader: false,
				firstLoader: true,
				errorconsulta: false,
				submitButton: true,
				mostrarLista: false,
				cargarDocto: false,
				exito: false,
				error: false,
				unDocumento: false,
				formulario: false,
				listaDocumentos: [],
				editarDocumento: [],
				totaldocumentos: 0,
				TipoEstudio: '',
				FechaEstudio: '',
				idConsulta: 0,
			}
		},

		created: function() {
			this.getDocumentos(this.idpaciente);
		},

		methods: {
			getDocumentos: function(idpaciente) {
				this.errorconsulta = false;
				this.$http.get('/api/documentos/' + idpaciente, function( documentos ){
					this.listaDocumentos = documentos;
					this.totaldocumentos = documentos.length;
					this.$dispatch('total-documentos', this.totaldocumentos);
				})
				.then(function() {
					this.firstLoader = false;
					this.cargarDocto = true;
				}, function() {
					this.firstLoader = false;
					this.errorconsulta = true;
				});
			},
			volveracargar: function() {
				this.getDocumentos(this.idpaciente);
			},
			verDocumento: function(documento) {
				this.editarDocumento = documento;
				this.showModal();
				this.formulario = false;
				this.unDocumento = true;
			},
			cargarDocumento: function(e) {
				if(this.TipoEstudio == '' || this.Descripcion == '' || this.Archivo == '') {
					this.error = true;
					return false;
				}
				this.Loader = true;
				this.submitButton = false;
				forma = $('form#formaDocumentos');
				forma.submit();
			},
			showModal: function() {
				this.unDocumento = false;
				this.modal = true;
				this.formulario = true;
				this.guardar = true;
			},
			closeModal: function() {
				this.modal = false;
				this.submitButton = true;
				this.exito = false;
				this.formulario = false;
				this.unDocumento = false;
			},
			deleteDocumento: function(docto) {
				swal({
					title: "Está seguro?",
					text: "El registro será eliminado y enviado a la Papelera de Reciclaje.",
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#DD6B55",
					confirmButtonText: "Si, Continuar!",
					cancelButtonText: "No, cancelar!",
					closeOnConfirm: false,
					closeOnCancel: true,
					showLoaderOnConfirm: true,
				}, function(isConfirm) {
					if (isConfirm) {
						// var valuetoken = document.querySelector('#_token').getAttribute('value');
						this.$http.delete('/api/trash-documento', {
							idEstudio: docto.idEstudio,
							// _token: valuetoken,
						})
						.then(function(datos) {
							if(datos.data == 1) {
				            	swal({
				            		title: "Eliminado!",
				            		text: "El Registro se ha enviado a la Papelera de Reciclaje",
				            		type: "success"
				            	});
			            	} else {
			            		swal({
				            		title: "Uppss",
				            		text: "El Registro no pudo ser enviado a la Papelera de Reciclaje",
				            		type: "error"
				            	});
							}
							this.getDocumentos(this.idpaciente);
						});
					} else {
						swal("Cancelado", "La solicitud ha sido cancelada :)", "error");
					}
				}.bind(this));
			},
		},

		computed: {
			mostrarLista: function() {
				if(this.listaDocumentos.length > 0) {
					return true;
				} else {
					return false;
				}
			},
			id_usr: function() {
				return this.idusr;
			}
		},
	});

	Vue.component('notas-inter', {
		template: '#notas-inter',

		props: ['idpaciente'],

		data: function () {
			return {
				listanotasinter: [],
				contarnotasinter: 0,
				notasinter: false,
				error: false,
			}
		},

		created: function() {
			this.searchNotasinter();
		},

		methods: {
			searchNotasinter: function() {
				this.$http.get('/api/notas/inter/'+ this.idpaciente , function (data){
					this.listanotasinter = data;
					this.contarnotasinter = data.length;
					this.$dispatch('total-notas-inter', this.contarnotasinter);
				})
				.then(function (){
					this.loading = false;
					this.notasinter = true;
					this.error = false;
					//revisarprogreso();
					this.$dispatch('total-notasinter', this.contarnotasinter);
				}, function(){
					this.error = true;
					this.contarnotasinter = 0;
					this.notasinter = false;
					//revisarprogreso();
				});
			}, // OK
			volveraCargarinter: function() {
				this.searchNotasinter();
			},
			deleteNotainter: function(notainter) {
				swal({
					title: "Está seguro?",
					text: "El registro será eliminado y enviado a la Papelera de Reciclaje.",
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#DD6B55",
					confirmButtonText: "Si, Continuar!",
					cancelButtonText: "No, cancelar!",
					closeOnConfirm: false,
					closeOnCancel: true,
					showLoaderOnConfirm: true,
				}, function(isConfirm) {
					if (isConfirm) {
						var valuetoken = document.querySelector('#_token').getAttribute('value');
						$.ajax({
				            url: '/api/delete/notas/inter/',
				            type:"DELETE",
				            async: true,
				            data: { id: notainter.idfn, _token: valuetoken }
				        })
				        .done(function(data){
							if(data == 1) {
				            	swal({
				            		title: "Eliminado!",
				            		text: "El Registro se ha enviado a la Papelera de Reciclaje",
				            		type: "success"
				            	}, function(){
				            		window.location.reload(true);
				            	});
			            	} else {
			            		swal({
				            		title: "Uppss",
				            		text: "El Registro no pudo ser enviado a la Papelera de Reciclaje",
				            		type: "error"
				            	});
							};
						});
					} else {
						swal("Cancelado", "La solicitud ha sido cancelada :)", "error");
					}
				});
			}, // OK
		},
	});

	Vue.http.headers.common['X-CSRF-TOKEN'] = document.querySelector('#_token').getAttribute('value');

	Vue.http.options.emulateJSON = true;

	Vue.transition('desvanece', {
		enterClass: 'fadeIn',
		leaveClass: 'fadeOut'
	});

	Vue.transition('roll', {
		enterClass: 'fadeIn',
		leaveClass: 'bounceOutUp'
	});

	Vue.transition('smallBig', {
		enterClass: 'zoomIn',
		leaveClass: 'zoomOut'
	});

	new Vue({
		el: '#app',

		data: {
			totalnotas: 0,
			totaldocumentos: 0,
			totalnotasinterconsultas: 0,
		},

		events: {
			'total-notas': function(notas) {
				this.totalnotas = notas;
			},
			'total-documentos': function(documentos) {
				this.totaldocumentos = documentos;
			},
			'total-notas-inter': function(inter) {
				this.totalnotasinterconsultas = inter;
			},
		},
	});

	Vue.filter('getHour', function (value) {
		//moment.locale('es');
		var date = moment(value).format('h:mm A');
	 	return date;
	});

	Vue.filter('getDate', function (value) {
		//moment.locale('es');
		var date = moment(value).format('MMM DD YYYY, h:mm A');
	 	return date;
	});

	Vue.filter('sinTexto', function(texto) {
		if(texto == '') return '';
	});

	Vue.filter('sinInfo', function(value) {
		// if(typeof string != undefined && string != null) return 'Sdp';
		if(value == '') return '';

		return value;
	});

	Vue.filter('breakString', {
		read: function(value) {
			return value;
		},
		write: function(value, oldValue) {
			if(typeof string != 'undefined' && string != null) return str = replaceAll(string, '.', '<br>');
		}
	});

	Vue.filter('breakPipe', {
		read: function(value) {
			return value;
		},
		write: function(value, oldValue) {
			return str = replaceAll(value, ' |', '<br>');
		},
	});

}) ( );
